/* ============================================================================
   Bundle Configurator — vanilla-JS port of docs/Rifle-Configurator.dc.html
   ----------------------------------------------------------------------------
   No React, no build step, no ES modules. Plain class instantiated by the
   Liquid section in configurator mode (?platform=<slug>).

   - Fetches the real App Proxy API (/apps/bundles/platforms/<slug>) and maps
     it onto the design's data model.
   - Holds the SAME state shape as the DC Component (theme/power/color/sel/
     open/search/sheet/montaje/qa*).
   - Implements EVERY behavior from the design: theme toggle, power select
     (+auto-spring + drop-incompatible WHEN compatibility data is present),
     color swatches (only when color data exists), accordion toggle, option
     select/deselect, qty steppers, OOS factory/alt, per-category search +
     "Buscar con IA" (deterministic keyword), montaje select, live summary
     (desktop sidebar + mobile bottom sheet), discount-tier progress + totals,
     animated "desde" counter, and the deterministic OpenClaw questionnaire.
   - NET-NEW (the old theme never wired this): add-to-cart pipeline
     configure -> cart -> /cart/add.js with graceful error handling, then
     opens the cart drawer (or redirects to /cart as a fallback).

   Feature-detected additive contract fields (backend can fill later) — see
   FEATURE-DETECTED CONTRACT section near the bottom of this file.
   ============================================================================ */
(function () {
  'use strict';

  /* ─── Tunables / config (single hook points) ─────────────────────────── */

  // Search box appears when a category is "large". Real API may expose an
  // explicit flag (category.search) or just a big option list / optionCount.
  var SEARCH_THRESHOLD = 40;

  // Qty steppers are enabled for consumable-style categories. Backend may add
  // an explicit `category.qtyEnabled` flag later; until then we name-match.
  var QTY_NAME_RE = /(cargador|magazine|bbs?|munici[oó]n|ammo|gas)/i;

  // The 5 fixed power tiers from the design. Used only when no real power
  // category data exists. spring = id of a spring option to auto-pick by
  // joule match against option.comp / option.joules when available.
  var POWER_TIERS = [
    { id: '1.3J', julios: '1.3J', fps: '374' },
    { id: '1.9J', julios: '1.9J', fps: '452' },
    { id: '2.3J', julios: '2.3J', fps: '498' },
    { id: '2.8J', julios: '2.8J', fps: '549' },
    { id: '3.0J', julios: '3.0J', fps: '568' }
  ];

  // Category name → power spring auto-pick lookup.
  var SPRING_NAME_RE = /(muelle|spring)/i;

  // Montaje service — config-driven (no real product id wired yet). Cost is
  // shown in the displayed total; on add-to-cart it is attached ONLY as a
  // line-item property note on the first bundle item (_bundle_montaje).
  var MONTAJE = [
    { id: 'none', name: 'Lo monto yo', price: 0,
      desc: 'Recibes todas las piezas sueltas, sin montar.', perks: [] },
    { id: 'std', name: 'Montaje profesional', price: 60,
      desc: 'Montado, engrasado y cronografiado en banco por nuestros armeros.',
      perks: ['Cronografiado incluido', 'Ajuste de hop-up', 'Garantía de montaje 6 meses'] },
    { id: 'prem', name: 'Montaje Premium Care', price: 220,
      desc: 'Todo lo del profesional, más un plan de mantenimiento completo.',
      perks: ['2 mantenimientos al año durante 2 años', 'Envío y recogida incluidos',
              'Reajuste de hop y cronografiado', 'Renovable cada 2 años'],
      badge: 'PLAN PRO' }
  ];
  var MONTAJE_NAME = { none: 'Sin montaje', std: 'Montaje profesional', prem: 'Montaje Premium Care' };

  // Discount tiers fallback (count-based) — replaced by API discountTiers when
  // the backend provides them.
  var DEFAULT_TIERS = [
    { minParts: 2, discountPct: 2 },
    { minParts: 3, discountPct: 5 },
    { minParts: 5, discountPct: 7 }
  ];

  // Categories that count as "installable" for the montaje/tier copy.
  var INSTALL_HINT_RE = /(ca[nñ][oó]n|barrel|hop|gatillo|trigger|muelle|spring|goma|bucking|pist[oó]n|piston|cilindro|cylinder|silenciador|suppres|culata|stock|visor|scope|montura|anilla|mount|b[ií]pode|bipod)/i;

  /* ─── Sequential compatibility cascade (config-driven, per platform) ──────
     Some platforms gate downstream categories behind a "root" choice that
     resolves a compatibility family. For the SRS A2/M2 the user must pick the
     HOP-UP CHAMBER first; that choice resolves a CUT FAMILY (aeg | vsr), and a
     fixed CHAIN of categories then shows ONLY options whose `.tags` intersect
     that family (untagged options stay UNIVERSAL → always shown).

     Platforms WITHOUT an entry here behave EXACTLY as before (no gating, API
     order). Categories are matched to canonical cascade slugs via an explicit
     feature-detected `category.slug` first, else a name/id alias resolver
     (CATEGORY_SLUG_ALIASES) — so render code never hardcodes real category ids. */
  var CASCADE_RULES = {
    'srs-a2-m2': {
      // Root category the whole cascade depends on (must be chosen first).
      gateCategory: 'hop-up-chamber',
      // Categories filtered by the active cut family, in cascade order.
      chain: ['bucking', 'inner-barrel', 'outer-barrel'],
      // Display order for this platform. Categories not listed keep their API
      // order AFTER the listed ones.
      order: ['hop-up-chamber', 'bucking', 'inner-barrel', 'outer-barrel',
              'suppressor', 'spring', 'piston', 'cylinder', 'trigger',
              'stock', 'scope', 'scope-mount', 'bipod'],
      // Cut family → set of compatibility tags. A chamber whose tags intersect
      // the vsr-family set resolves family='vsr'; otherwise family='aeg'.
      cutFamilies: {
        aeg: ['aeg-cut', 'srs-stock-chamber'],
        vsr: ['srs-morpheus-chamber', 'vsr-cut', 'gbb-cut']
      },
      // Suppressor is NOT filtered by cut family (a thread rule comes later).
      suppressorByThread: true,
      // PROMOTED optional categories: rendered open by default with a
      // recommended star pre-selected (like required cats), while staying
      // OPTIONAL (the customer can deselect; never counted as a missing
      // required component). Matched by canonical cascade slug.
      promote: ['suppressor']
    }
  };

  // Canonical cascade slug → regex matched against a category's slug/name/id.
  // Order matters: more specific patterns (inner/outer barrel, scope-mount)
  // are tested before the generic ones.
  var CATEGORY_SLUG_ALIASES = [
    { slug: 'hop-up-chamber', re: /(hop[\s_-]*up|c[áa]mara.*hop|hop.*chamber|chamber)/i },
    { slug: 'bucking',        re: /(bucking|goma)/i },
    { slug: 'inner-barrel',   re: /(inner[\s_-]*barrel|ca[nñ][oó]n\s*(interno|interior)|barrel.*inner)/i },
    { slug: 'outer-barrel',   re: /(outer[\s_-]*barrel|ca[nñ][oó]n\s*(externo|exterior)|barrel.*outer)/i },
    { slug: 'suppressor',     re: /(suppres|silenciador)/i },
    { slug: 'spring',         re: /(muelle|spring)/i },
    { slug: 'piston',         re: /(pist[oó]n|piston)/i },
    { slug: 'cylinder',       re: /(cilindro|cylinder)/i },
    { slug: 'trigger',        re: /(gatillo|trigger)/i },
    { slug: 'stock',          re: /(culata|\bstock\b)/i },
    { slug: 'scope-mount',    re: /(montura|anilla|\bmount\b|ring)/i },
    { slug: 'scope',          re: /(visor|scope|[oó]ptica|mira)/i },
    { slug: 'bipod',          re: /(b[ií]pode|bipod)/i }
  ];

  // Gated-state copy for chain categories before the chamber is chosen.
  var CASCADE_GATE_NOTE = 'Elige primero la cámara de hop';

  /* ─── Tiny helpers ───────────────────────────────────────────────────── */

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function escAttr(s) {
    return esc(s).replace(/"/g, '&quot;');
  }
  function fmtEUR(n) {
    var parts = (Math.round(n * 100) / 100).toFixed(2).split('.');
    var g = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + g + ',' + parts[1];
  }
  function eur(n) { return fmtEUR(n) + ' EUR'; }
  function slugifyId(s) { return String(s).replace(/[^a-z0-9_-]/gi, '_'); }

  /* ─── Component ──────────────────────────────────────────────────────── */

  function BundleConfigurator(opts) {
    this.mount = opts.mount;                 // DOM node to render into
    this.slug = opts.slug;                   // platform slug
    this.apiBase = opts.apiBase || '/apps/bundles';
    this.basePrice = typeof opts.basePrice === 'number' ? opts.basePrice : 0;
    this.hasBasePrice = opts.basePrice != null && !isNaN(opts.basePrice);

    // Real platform model (mapped from API). Filled in load().
    this.P = null;
    this.platformId = null;
    this.discountTiers = null;
    // Sequential compatibility cascade config for this platform (null = none).
    this.cascade = null;

    // Bound handler registry — the render produces buttons/inputs with
    // data-act / data-cat / data-opt; we delegate via a single listener so
    // re-renders don't leak listeners.
    this._bound = false;

    // Animated "desde" counter state.
    this._target = null;
    this._disp = 0;
    this._iv = null;

    // Spring auto-pick override flag (mirrors DC `springManual`).
    this.springManual = false;

    // Registry of catId → true for selections WE auto-made (star pre-selection).
    // Lets the cascade re-pick a new star without clobbering explicit user
    // picks (a key present in state.sel but ABSENT here is the user's choice).
    this._autoSel = {};

    // Add-to-cart busy guard.
    this._adding = false;

    this.GREETING = '¡Hola! Soy OpenClaw. Cuéntame qué rifle quieres y te lo configuro paso a paso. Empecemos 👇';

    this.state = {
      theme: 'light',
      power: '2.3J',
      color: null,            // set after we know whether color data exists
      sel: {},
      open: {},
      // Per-category "Ver N opciones compatibles" disclosure (the non-star
      // options collapse behind this; collapsed by default).
      restOpen: {},
      search: {},
      sheet: false,
      montaje: 'none',
      qaStep: 0,
      qaInput: '',
      aiMsgs: [],
      cartError: ''
    };
  }

  /* ─── State plumbing (React-ish setState that re-renders) ────────────── */

  BundleConfigurator.prototype.setState = function (patch) {
    var next = typeof patch === 'function' ? patch(this.state) : patch;
    var key;
    for (key in next) { if (next.hasOwnProperty(key)) this.state[key] = next[key]; }
    this.render();
    this.afterRender();
  };

  /* ─── API load + mapping ─────────────────────────────────────────────── */

  BundleConfigurator.prototype.load = function () {
    var self = this;
    this.renderState('loading', 'Cargando configurador…');
    return fetch(this.apiBase + '/platforms/' + encodeURIComponent(this.slug), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Platform not found (' + r.status + ')');
        return r.json();
      })
      .then(function (data) { self.applyData(data); })
      .catch(function (e) {
        if (window.console) console.error('[bundle-configurator] load error:', e);
        self.renderState('error',
          'No se pudo cargar el configurador. <a href="' + escAttr(window.location.pathname) + '">Volver</a>');
      });
  };

  // Map the real /platforms/<slug> response onto the design's data model.
  BundleConfigurator.prototype.applyData = function (data) {
    var self = this;
    var platform = data.platform || {};
    this.platformId = data.platformId != null ? data.platformId : platform.id;
    this.discountTiers = (data.discountTiers && data.discountTiers.length) ? data.discountTiers.slice() : null;

    var cats = (data.categories || []).map(function (cat) {
      var rawOpts = cat.options || [];
      var optionCount = (typeof cat.optionCount === 'number') ? cat.optionCount : rawOpts.length;

      // FEATURE-DETECT: categoryKind ('power'|'color'|'part', default 'part').
      var kind = cat.categoryKind || 'part';

      // search box when explicit flag OR large option list / optionCount.
      var hasSearch = (cat.search === true) ||
        (rawOpts.length >= SEARCH_THRESHOLD) ||
        (optionCount >= SEARCH_THRESHOLD);

      // qty steppers: explicit flag OR name match (consumables).
      var qtyEnabled = (cat.qtyEnabled === true) || QTY_NAME_RE.test(cat.name || '');

      var opts = rawOpts.map(function (o) {
        return self.mapOption(o);
      });

      return {
        id: String(cat.id),
        name: cat.name || '',
        // Canonical cascade slug: explicit `category.slug` (feature-detected)
        // else resolved from name/id via CATEGORY_SLUG_ALIASES (null when none).
        slug: self.resolveCategorySlug(cat),
        req: !!cat.required,
        multiSelect: !!cat.multiSelect,
        count: optionCount,
        categoryKind: kind,
        // FEATURE-DETECT min/max selectable (currently unused beyond required)
        minSelectable: (typeof cat.minSelectable === 'number') ? cat.minSelectable : null,
        maxSelectable: (typeof cat.maxSelectable === 'number') ? cat.maxSelectable : null,
        search: hasSearch,
        qtyEnabled: qtyEnabled,
        sortOrder: cat.sortOrder,
        opts: opts
      };
    });

    // Stable order by sortOrder when present.
    cats.sort(function (a, b) {
      var sa = (a.sortOrder == null) ? 1e9 : a.sortOrder;
      var sb = (b.sortOrder == null) ? 1e9 : b.sortOrder;
      return sa - sb;
    });

    // Resolve the cascade config for this platform (null when none → no gating,
    // current order preserved exactly). Reorder per cascade.order when present.
    this.cascade = CASCADE_RULES[this.P_slug(platform)] || null;
    if (this.cascade) cats = this.applyCascadeOrder(cats, this.cascade);

    this.P = {
      name: platform.name || this.slug,
      brand: platform.baseModel || platform.brand || '',
      slug: platform.slug || this.slug,
      type: platform.type || '',
      base: this.hasBasePrice ? this.basePrice : 0,
      hasBase: this.hasBasePrice && this.basePrice > 0,
      gas: true, // gasOnly categories only existed in the mock; show all real cats
      categories: cats
    };

    // Color data: only present if a 'color' category or option colorName/Hex.
    this.colors = this.deriveColors(cats);

    // Power data: explicit power category OR fixed tiers (design fallback).
    this.powers = this.derivePowers(cats);

    // Spring category id for auto-pick (name match).
    var springCat = cats.find(function (c) { return SPRING_NAME_RE.test(c.name); });
    this.springCatId = springCat ? springCat.id : null;

    // Whether ANY option carries compatibility info (joules/comp). Controls
    // the "drop incompatible" + power-note behavior.
    this.hasCompat = cats.some(function (c) {
      return c.opts.some(function (o) { return o.comp && o.comp.length; });
    });

    // Init accordion open-state: required categories (and promoted optional
    // categories, e.g. suppressor) open by default.
    var open = {};
    cats.forEach(function (c) { open[c.id] = c.req || self.isPromoted(c); });

    // Default color = first available, else null (hides swatch row).
    var defColor = this.colors.length ? this.colors[0].id : null;

    // Default power = a middle tier that exists.
    var defPower = this.powers.length ? this.powers[Math.min(2, this.powers.length - 1)].id : null;

    this.setStateRaw({
      open: open,
      color: defColor,
      power: defPower,
      aiMsgs: this.powers.length
        ? [{ who: 'bot', text: this.GREETING }, { who: 'bot', text: this.flow()[0].q }]
        : [{ who: 'bot', text: this.GREETING }]
    });

    // STAR pre-selection: arrive pre-filled with a valid recommended build the
    // customer just reviews. Required categories (and the cascade gate) get
    // their star; optional categories do NOT. Power must be set first (stars
    // are picked among power-compatible options) — hence after setStateRaw.
    // Operates directly on this.state.sel so the cascade/family is read live.
    this.preselectStars(this.state.sel);

    // First paint + animated counter init.
    this.render();
    var t = this.totals().total;
    this._target = t;
    this._disp = t;
    this.afterRender();
  };

  // setStateRaw mutates without triggering a render (used during init).
  BundleConfigurator.prototype.setStateRaw = function (patch) {
    var key;
    for (key in patch) { if (patch.hasOwnProperty(key)) this.state[key] = patch[key]; }
  };

  // Map a single API option to the design's opt shape.
  BundleConfigurator.prototype.mapOption = function (o) {
    var s = 'in';
    if (o.stockStatus === 'preorder') s = 'pre';
    else if (o.stockStatus === 'unavailable') s = 'oos';
    else s = 'in'; // 'available' or unknown -> in stock

    // FEATURE-DETECT compatibility: option.comp (array of joule ids) OR
    // option.joules (single value we wrap into a one-element comp array).
    var comp = null;
    if (Array.isArray(o.comp) && o.comp.length) comp = o.comp.slice();
    else if (o.joules != null) comp = [String(o.joules).replace(/J?$/, 'J')];

    // FEATURE-DETECT cut/cascade compatibility tags: option.compatibility OR
    // option.tags (string[]). Untagged → [] (treated as UNIVERSAL by the
    // cascade filter). This is independent of the joule `comp` above.
    var tags = [];
    if (Array.isArray(o.compatibility)) tags = o.compatibility.map(String);
    else if (Array.isArray(o.tags)) tags = o.tags.map(String);

    return {
      id: String(o.id),
      t: o.title || '',
      br: o.brandLine || o.brand || '',
      p: typeof o.price === 'number' ? o.price : Number(o.price) || 0,
      compareAt: (o.compareAtPrice != null) ? Number(o.compareAtPrice) : null,
      s: s,
      low: (o.stockStatus === 'available' && typeof o.inventoryQty === 'number' && o.inventoryQty > 0 && o.inventoryQty <= 5),
      sku: o.sku || '',
      variantId: (o.variantId != null) ? o.variantId : (o.variant_id != null ? o.variant_id : null),
      imageUrl: o.imageUrl || '',
      comp: comp,
      tags: tags,
      // FEATURE-DETECT star recommendation: option.recommended (boolean, already
      // in the API) flags the editorially-recommended option for its category.
      // option.recommendationReason (string) is the NEW additive field the
      // backend will add later — feature-detected here; null until present.
      recommended: o.recommended === true,
      recommendationReason: (typeof o.recommendationReason === 'string' && o.recommendationReason.trim())
        ? o.recommendationReason.trim() : null,
      // FEATURE-DETECT power/color metadata
      fps: o.fps != null ? String(o.fps) : null,
      joules: o.joules != null ? String(o.joules) : null,
      colorName: o.colorName || null,
      colorHex: o.colorHex || null
    };
  };

  // Derive color swatches. Returns [] when there is no color data → row hidden.
  BundleConfigurator.prototype.deriveColors = function (cats) {
    var colorCat = cats.find(function (c) { return c.categoryKind === 'color'; });
    var src = colorCat ? colorCat.opts : null;
    if (!src) {
      // Look for any options carrying colorName/colorHex.
      src = [];
      cats.forEach(function (c) {
        c.opts.forEach(function (o) { if (o.colorName && o.colorHex) src.push(o); });
      });
    }
    var seen = {};
    var out = [];
    src.forEach(function (o) {
      var name = o.colorName || o.t;
      var hex = o.colorHex;
      if (!name || !hex) return;
      var id = slugifyId((o.colorName || o.t || '').toLowerCase());
      if (seen[id]) return;
      seen[id] = 1;
      out.push({ id: id, name: name, hex: hex });
    });
    return out;
  };

  // Derive power tiers. Prefer an explicit 'power' category; else the design's
  // fixed 5 tiers (enriched with fps/joules when options expose them).
  BundleConfigurator.prototype.derivePowers = function (cats) {
    var powerCat = cats.find(function (c) { return c.categoryKind === 'power'; });
    if (powerCat && powerCat.opts.length) {
      return powerCat.opts.map(function (o) {
        var j = o.joules || (o.t || '').match(/(\d+\.?\d*)\s*J/i);
        var jid = (o.joules ? (String(o.joules).replace(/J?$/, 'J')) : (Array.isArray(j) ? j[1] + 'J' : o.t));
        return { id: jid, julios: jid, fps: o.fps || '', optionId: o.id };
      });
    }
    // Fixed tiers fallback.
    return POWER_TIERS.map(function (t) { return { id: t.id, julios: t.julios, fps: t.fps }; });
  };

  /* ─── Cascade (sequential, compatibility-gated) helpers ──────────────── */

  // Platform slug used to look up CASCADE_RULES (mirror of this.P.slug logic
  // but available before this.P is built).
  BundleConfigurator.prototype.P_slug = function (platform) {
    return (platform && platform.slug) || this.slug;
  };

  // Resolve a raw API category to its canonical cascade slug. Prefers an
  // explicit `category.slug`; else matches name/id against CATEGORY_SLUG_ALIASES.
  BundleConfigurator.prototype.resolveCategorySlug = function (cat) {
    if (cat.slug) return String(cat.slug);
    var hay = ((cat.name || '') + ' ' + (cat.id != null ? cat.id : '')).trim();
    for (var i = 0; i < CATEGORY_SLUG_ALIASES.length; i++) {
      if (CATEGORY_SLUG_ALIASES[i].re.test(hay)) return CATEGORY_SLUG_ALIASES[i].slug;
    }
    return null;
  };

  // Reorder categories per cascade.order. Listed slugs come first in order;
  // unlisted categories keep their incoming (API) order after them.
  BundleConfigurator.prototype.applyCascadeOrder = function (cats, cascade) {
    var order = cascade.order || [];
    var rank = {};
    order.forEach(function (slug, i) { rank[slug] = i; });
    // Decorate-sort-undecorate for a STABLE sort (Array.sort is not guaranteed
    // stable across all engines; the original index is the tie-breaker).
    return cats
      .map(function (c, i) {
        var r = (c.slug != null && rank[c.slug] != null) ? rank[c.slug] : (order.length + i);
        return { c: c, r: r, i: i };
      })
      .sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); })
      .map(function (x) { return x.c; });
  };

  // The category object acting as the cascade gate (chamber), or null.
  BundleConfigurator.prototype.gateCat = function () {
    if (!this.cascade) return null;
    var slug = this.cascade.gateCategory;
    return this.P.categories.find(function (c) { return c.slug === slug; }) || null;
  };

  // True when the given category is part of the family-filtered chain.
  BundleConfigurator.prototype.isChainCat = function (cat) {
    return !!(this.cascade && cat && cat.slug && this.cascade.chain.indexOf(cat.slug) >= 0);
  };

  // True when the category is a PROMOTED optional category for this platform:
  // shown open by default with a recommended star pre-selected (like required
  // cats), while remaining OPTIONAL (the customer can deselect; never counted
  // as a missing required component). Config-driven via cascade.promote
  // (canonical cascade slugs). No-op when there is no cascade for the platform.
  BundleConfigurator.prototype.isPromoted = function (cat) {
    return !!(this.cascade && cat && cat.slug &&
              (this.cascade.promote || []).indexOf(cat.slug) >= 0);
  };

  // Active cut family resolved from the CURRENTLY-SELECTED gate option, or null
  // when no cascade / no chamber chosen yet. A chamber whose tags intersect the
  // vsr-family tag set → 'vsr'; otherwise (incl. default/untagged) → 'aeg'.
  BundleConfigurator.prototype.activeCutFamily = function () {
    if (!this.cascade) return null;
    var gate = this.gateCat();
    if (!gate) return null;
    var sel = this.state.sel[gate.id];
    if (!sel) return null;
    var opt = this.findOpt(gate.id, sel.opt);
    if (!opt) return null;
    var fams = this.cascade.cutFamilies || {};
    var vsr = fams.vsr || [];
    var tags = opt.tags || [];
    var hitsVsr = tags.some(function (t) { return vsr.indexOf(t) >= 0; });
    return hitsVsr ? 'vsr' : 'aeg';
  };

  // Set of tags that DEFINE the OTHER family (used to hide options that
  // explicitly belong to the wrong cut). Untagged / cross-cut options are NOT
  // hidden by this — only options carrying a tag exclusive to the other family.
  BundleConfigurator.prototype.otherFamilyExclusiveTags = function (family) {
    var fams = (this.cascade && this.cascade.cutFamilies) || {};
    var own = fams[family] || [];
    var other = (family === 'vsr') ? (fams.aeg || []) : (fams.vsr || []);
    // A tag is "exclusive to the other family" iff it is in the other set and
    // NOT shared with the active family's set.
    return other.filter(function (t) { return own.indexOf(t) < 0; });
  };

  // Visibility of an option inside a chain category, given the active family.
  // Rules (per brief):
  //   - No family yet → not visible (the category renders gated, see render).
  //   - Option whose tags intersect the active family's tags → visible.
  //   - Untagged / no cut tags from either family → UNIVERSAL → visible.
  //   - Only hide options that carry a cut tag EXCLUSIVE to the OTHER family.
  BundleConfigurator.prototype.optionVisibleInChain = function (opt, family) {
    if (!family) return false;
    var tags = opt.tags || [];
    var fams = (this.cascade && this.cascade.cutFamilies) || {};
    var own = fams[family] || [];
    if (tags.some(function (t) { return own.indexOf(t) >= 0; })) return true; // active family match
    var otherExcl = this.otherFamilyExclusiveTags(family);
    var carriesOther = tags.some(function (t) { return otherExcl.indexOf(t) >= 0; });
    return !carriesOther; // universal/untagged → show; other-cut-only → hide
  };

  // After a gate (chamber) change, drop any chain selection no longer visible
  // under the new family. Mirrors the existing power-prune in setPower. Mutates
  // and returns the passed `sel` map.
  BundleConfigurator.prototype.pruneCascade = function (sel) {
    if (!this.cascade) return sel;
    var self = this;
    var family = this.activeCutFamily();
    this.P.categories.forEach(function (cat) {
      if (!self.isChainCat(cat)) return;
      var cur = sel[cat.id];
      if (!cur) return;
      if (!family) { delete sel[cat.id]; return; } // gate cleared → drop chain
      var o = self.findOpt(cat.id, cur.opt);
      if (!o || !self.optionVisibleInChain(o, family)) delete sel[cat.id];
    });
    return sel;
  };

  /* ─── Star recommendation (per-category prominent + pre-select) ───────────
     The STAR is the single recommended option shown prominently at the top of
     a category, pre-selected for required categories. It is chosen among the
     CURRENTLY-VISIBLE (compatible) options — i.e. what the cascade + power
     filters already left for this category under the active cut family. */

  // Visible/compatible options for a category, ignoring the per-category search
  // box (the star must be stable while the user filters). Mirrors the filtering
  // computeView applies: power compatibility + (chain) cut-family visibility.
  // Returns [] for a gated chain category (no chamber chosen yet).
  BundleConfigurator.prototype.visibleOpts = function (cat) {
    var self = this;
    var opts = cat.opts.filter(function (o) { return self.compatible(o, self.state.power); });
    if (this.isChainCat(cat)) {
      var fam = this.activeCutFamily();
      if (!fam) return [];
      opts = opts.filter(function (o) { return self.optionVisibleInChain(o, fam); });
    }
    return opts;
  };

  // Deterministic, stable star pick among a list of already-visible options:
  //   1. an option with recommended === true (lowest id wins on ties);
  //   2. else the lowest-price in-stock option;
  //   3. else the lowest-price option overall.
  // Ties are broken by ascending option id so the choice is stable across
  // re-renders and reorders. Returns the option object or null.
  BundleConfigurator.prototype.pickStar = function (opts) {
    if (!opts || !opts.length) return null;
    var byId = function (a, b) { return a.id < b.id ? -1 : (a.id > b.id ? 1 : 0); };
    var rec = opts.filter(function (o) { return o.recommended; }).sort(byId);
    if (rec.length) return rec[0];
    var byPrice = function (a, b) { return (a.p - b.p) || byId(a, b); };
    var inStock = opts.filter(function (o) { return o.s === 'in'; }).sort(byPrice);
    if (inStock.length) return inStock[0];
    return opts.slice().sort(byPrice)[0];
  };

  // The star option for a category given the current cascade/power state, or
  // null when the category has no visible options (e.g. gated chain).
  BundleConfigurator.prototype.starOpt = function (cat) {
    return this.pickStar(this.visibleOpts(cat));
  };

  // Reason line for the star card (Spanish). Uses the feature-detected
  // option.recommendationReason when the backend provides it; otherwise builds
  // a clean template from real attributes (no TODO/placeholder fallback).
  BundleConfigurator.prototype.starReason = function (cat, opt, visible) {
    if (!opt) return '';
    if (opt.recommendationReason) return opt.recommendationReason;
    var inStock = opt.s === 'in';
    var bits = [];
    if (opt.recommended) {
      bits.push('elección de Skirmshop');
    } else {
      // Cheapest in-stock among the visible options → value framing.
      var cheapestInStock = null;
      (visible || []).forEach(function (o) {
        if (o.s !== 'in') return;
        if (!cheapestInStock || o.p < cheapestInStock.p ||
            (o.p === cheapestInStock.p && o.id < cheapestInStock.id)) cheapestInStock = o;
      });
      if (inStock && cheapestInStock && cheapestInStock.id === opt.id) bits.push('mejor relación calidad-precio');
      else bits.push('recomendada');
    }
    if (inStock) bits.push('en stock');
    else if (opt.s === 'pre') bits.push('reserva disponible');
    else bits.push('bajo pedido a fábrica');
    bits.push(this.isChainCat(cat) ? 'compatible con tu cámara de hop' : 'compatible con tu configuración');
    // Capitalize the first segment.
    var s = bits.join(' · ');
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  // Pre-select the star into required categories (and the cascade gate), unless
  // the user has already chosen in that category. Idempotent: re-running keeps
  // a valid recommended build. The gate is resolved FIRST so the cut family is
  // known before chain stars are picked, then a prune drops any stale chain
  // selection, then chain/required stars are (re)picked. We track which keys
  // were auto-selected (this._autoSel) so a cascade change can re-pick the new
  // star WITHOUT ever clobbering an explicit user choice.
  //
  // Mutates and returns the passed `sel` map. Reads cut family off this.state,
  // so callers must reflect the pending `sel` into this.state.sel first OR call
  // this on a sel that is already this.state.sel (init path does the latter).
  BundleConfigurator.prototype.preselectStars = function (sel) {
    var self = this;
    if (!this._autoSel) this._autoSel = {};
    var auto = this._autoSel;

    var preselectCat = function (cat) {
      // Never touch a category the user explicitly picked. A key is "user's"
      // when it's selected but NOT in our auto registry.
      if (sel[cat.id] && !auto[cat.id]) return;
      var star = self.starOpt(cat);
      if (!star) {
        // No visible option (e.g. gated chain): clear any stale auto pick.
        if (sel[cat.id] && auto[cat.id]) { delete sel[cat.id]; delete auto[cat.id]; }
        return;
      }
      // Already on the right star (auto) → nothing to do.
      if (sel[cat.id] && sel[cat.id].opt === star.id && auto[cat.id]) return;
      sel[cat.id] = { opt: star.id, mode: star.s === 'oos' ? 'factory' : 'in', qty: 1 };
      auto[cat.id] = true;
    };

    // 1) Gate first (so the family resolves before chain stars).
    var gate = this.gateCat();
    if (gate) {
      preselectCat(gate);
      // Reflect the (possibly new) gate selection so activeCutFamily/prune see it.
      var prev = this.state.sel;
      this.state.sel = sel;
      this.pruneCascade(sel);
      // Drop auto registry entries whose selection got pruned.
      Object.keys(auto).forEach(function (k) { if (!sel[k]) delete auto[k]; });
      this.state.sel = prev;
    }

    // 2) Required categories + chain categories get their star (chain only once
    //    the family is resolved → visibleOpts returns []. gated → skipped).
    var prev2 = this.state.sel;
    this.state.sel = sel; // family-aware visibleOpts during the loop
    this.P.categories.forEach(function (cat) {
      if (gate && cat.id === gate.id) return;     // already handled
      if (cat.categoryKind === 'power' || cat.categoryKind === 'color') return;
      if (!cat.req && !self.isPromoted(cat)) return; // optional & not promoted: never auto-select
      preselectCat(cat);
    });
    this.state.sel = prev2;
    return sel;
  };

  /* ─── Questionnaire flow (deterministic, ported verbatim) ────────────── */

  BundleConfigurator.prototype.flow = function () {
    return [
      { id: 'power', q: '¿A qué potencia vas a jugar? (el límite de tu campo)', opts: [
        { l: '1.3J · CQB', v: '1.3J' }, { l: '1.9J', v: '1.9J' }, { l: '2.3J', v: '2.3J' },
        { l: '2.8J', v: '2.8J' }, { l: '3.0J · DMR', v: '3.0J' }, { l: 'No sé, recomiéndame', v: 'rec' }
      ] },
      { id: 'range', q: '¿Cómo lo quieres montar?', opts: [
        { l: 'Más corto y manejable', v: 'short' }, { l: 'Equilibrado', v: 'bal' }, { l: 'Largo alcance', v: 'long' }
      ] },
      { id: 'priority', q: '¿Qué priorizas en este build?', opts: [
        { l: 'Máxima precisión', v: 'precision' }, { l: 'Fiabilidad', v: 'reliab' }, { l: 'Ajustar presupuesto', v: 'budget' }
      ] },
      { id: 'finish', q: '¿Te importan los acabados?', opts: [
        { l: 'Sí, look premium metalizado', v: 'metal' }, { l: 'Lo más discreto posible', v: 'stealth' }, { l: 'Me da igual', v: 'any' }
      ] },
      { id: 'optics', q: 'Por último, ¿añadimos óptica y soporte?', opts: [
        { l: 'Visor + anillas', v: 'scope' }, { l: 'Visor + anillas + bípode', v: 'scopebipod' }, { l: 'Solo el rifle', v: 'none' }
      ] }
    ];
  };

  /* ─── Domain helpers (ported) ────────────────────────────────────────── */

  BundleConfigurator.prototype.fmt = fmtEUR;
  BundleConfigurator.prototype.eur = function (n) { return eur(n); };

  BundleConfigurator.prototype.findCat = function (catId) {
    return this.P.categories.find(function (c) { return c.id === catId; });
  };
  BundleConfigurator.prototype.findOpt = function (catId, optId) {
    var c = this.findCat(catId);
    return c && c.opts.find(function (o) { return o.id === optId; });
  };
  BundleConfigurator.prototype.recSpring = function () {
    // Auto-pick the spring option in the spring category whose comp matches
    // the current power. Returns option id or null.
    if (!this.springCatId) return null;
    var cat = this.findCat(this.springCatId);
    if (!cat) return null;
    var pw = this.state.power;
    var match = cat.opts.find(function (o) { return o.comp && o.comp.indexOf(pw) >= 0; });
    if (match) return match.id;
    // Fall back to a name match like "M150 / 2.3J" containing the joules.
    var jnum = (pw || '').replace('J', '');
    match = cat.opts.find(function (o) { return (o.t || '').indexOf(jnum) >= 0; });
    return match ? match.id : null;
  };
  BundleConfigurator.prototype.compatible = function (o, pw) {
    return !o.comp || !o.comp.length || o.comp.indexOf(pw) >= 0;
  };
  BundleConfigurator.prototype.pick = function (sel, catId, optId) {
    var o = this.findOpt(catId, optId);
    if (o) sel[catId] = { opt: optId, mode: o.s === 'oos' ? 'factory' : 'in' };
  };

  BundleConfigurator.prototype.tiers = function () {
    return this.discountTiers || DEFAULT_TIERS;
  };

  BundleConfigurator.prototype.totals = function () {
    var self = this;
    var parts = 0, count = 0, installCount = 0;
    Object.keys(this.state.sel).forEach(function (cid) {
      var sel = self.state.sel[cid];
      var o = self.findOpt(cid, sel.opt);
      if (o) {
        var qty = sel.qty || 1;
        parts += o.p * qty;
        count++;
        var cat = self.findCat(cid);
        if (cat && INSTALL_HINT_RE.test(cat.name)) installCount++;
      }
    });

    // Discount tier from API (count-based) — pick highest matching tier.
    var tierPct = 0;
    var tiers = this.tiers().slice().sort(function (a, b) { return a.minParts - b.minParts; });
    tiers.forEach(function (t) {
      if (count >= t.minParts) tierPct = (t.discountPct != null ? t.discountPct : (t.discountPercent || 0));
    });
    var tier = tierPct / 100;
    var disc = parts * tier;

    var montDef = MONTAJE.find(function (m) { return m.id === self.state.montaje; }) || MONTAJE[0];
    var montCost = montDef.price || 0;

    var total = (this.P.base || 0) + parts - disc + montCost;
    return {
      parts: parts, count: count, tier: tier, disc: disc, total: total,
      installCount: installCount, montCost: montCost, tiers: tiers
    };
  };

  /* ─── Actions (ported behavior) ──────────────────────────────────────── */

  BundleConfigurator.prototype.setTheme = function () {
    this.setState(function (s) { return { theme: s.theme === 'dark' ? 'light' : 'dark' }; });
  };

  BundleConfigurator.prototype.setPower = function (id) {
    var self = this;
    this.setState(function (s) {
      var sel = Object.assign({}, s.sel);
      // Drop selections no longer compatible with the new power — only when
      // compatibility data exists (otherwise no-op, per the brief).
      if (self.hasCompat) {
        self.P.categories.forEach(function (cat) {
          var cur = sel[cat.id]; if (!cur) return;
          var o = self.findOpt(cat.id, cur.opt);
          if (o && !self.compatible(o, id)) delete sel[cat.id];
        });
      }
      // Auto spring (unless user picked one manually), only if we have a
      // spring category to auto-pick from.
      if (self.springCatId && (!self.springManual || !sel[self.springCatId])) {
        // temporarily set power so recSpring uses the new value
        var prevPower = self.state.power;
        self.state.power = id;
        var sp = self.recSpring();
        self.state.power = prevPower;
        if (sp) {
          var o = self.findOpt(self.springCatId, sp);
          sel[self.springCatId] = { opt: sp, mode: o.s === 'oos' ? 'factory' : 'in' };
        }
      }
      // Re-pick required-category stars whose auto-selection got dropped by the
      // power prune (only meaningful when compatibility data exists; otherwise
      // the prune was a no-op and stars are unchanged). Drop stale auto entries
      // first so repick fills the holes with the new power-compatible star.
      if (self.hasCompat) {
        var auto = self._autoSel || (self._autoSel = {});
        Object.keys(auto).forEach(function (k) { if (!sel[k]) delete auto[k]; });
        var prevPower = self.state.power, prevSel = self.state.sel;
        self.state.power = id; self.state.sel = sel;
        self.repickRequiredStars(sel);
        self.state.power = prevPower; self.state.sel = prevSel;
      }
      return { power: id, sel: sel };
    });
  };

  // True when catId is the cascade gate (chamber) for the active platform.
  BundleConfigurator.prototype.isGateCatId = function (catId) {
    var gate = this.gateCat();
    return !!(gate && gate.id === catId);
  };

  // When the changed category is the cascade gate, prune chain selections that
  // are no longer compatible under the (now updated) sel map, then re-pick the
  // star for any required/chain category left empty under the NEW cut family
  // (so a chamber change yields a fresh valid recommended downstream build
  // instead of leaving holes). User-chosen downstream picks are preserved by
  // preselectStars' auto-registry. No-op when not the gate / no cascade.
  BundleConfigurator.prototype.pruneIfGate = function (catId, sel) {
    if (!this.cascade || !this.isGateCatId(catId)) return sel;
    // activeCutFamily reads this.state.sel, so reflect the pending sel first.
    var prevSel = this.state.sel;
    this.state.sel = sel;
    this.pruneCascade(sel);
    // Drop auto-registry entries whose selection got pruned, then re-pick stars.
    var auto = this._autoSel || (this._autoSel = {});
    Object.keys(auto).forEach(function (k) { if (!sel[k]) delete auto[k]; });
    this.repickRequiredStars(sel);
    this.state.sel = prevSel;
    return sel;
  };

  // Re-pick the star for required (incl. chain) categories left empty or holding
  // a now-auto-stale pick, WITHOUT re-forcing the gate itself (the gate is the
  // user's current choice). Reads cut family off this.state.sel, so callers must
  // reflect the pending sel into this.state.sel first. Mutates `sel`.
  BundleConfigurator.prototype.repickRequiredStars = function (sel) {
    var self = this;
    var auto = this._autoSel || (this._autoSel = {});
    var gate = this.gateCat();
    this.P.categories.forEach(function (cat) {
      if (gate && cat.id === gate.id) return;             // never re-force the gate
      if (cat.categoryKind === 'power' || cat.categoryKind === 'color') return;
      if (!cat.req) return;                                // optional: never auto-select
      if (sel[cat.id] && !auto[cat.id]) return;            // user's explicit pick
      var star = self.starOpt(cat);
      if (!star) { if (sel[cat.id] && auto[cat.id]) { delete sel[cat.id]; delete auto[cat.id]; } return; }
      if (sel[cat.id] && sel[cat.id].opt === star.id && auto[cat.id]) return;
      sel[cat.id] = { opt: star.id, mode: star.s === 'oos' ? 'factory' : 'in', qty: 1 };
      auto[cat.id] = true;
    });
    return sel;
  };

  // A category the user explicitly acted on is no longer auto-managed: drop it
  // from the star auto-registry so preselectStars/repick never overwrite it.
  BundleConfigurator.prototype.markUserChoice = function (catId) {
    if (this._autoSel) delete this._autoSel[catId];
  };

  BundleConfigurator.prototype.toggleStock = function (catId, optId) {
    var self = this;
    if (catId === this.springCatId) this.springManual = true;
    this.markUserChoice(catId);
    var cur = this.state.sel[catId];
    if (cur && cur.opt === optId) {
      this.setState(function (s) {
        var n = Object.assign({}, s.sel); delete n[catId];
        self.pruneIfGate(catId, n);
        return { sel: n };
      });
    } else {
      this.setState(function (s) {
        var n = Object.assign({}, s.sel);
        n[catId] = { opt: optId, mode: 'in', qty: 1 };
        self.pruneIfGate(catId, n);
        return { sel: n };
      });
    }
  };

  BundleConfigurator.prototype.setQty = function (catId, delta) {
    this.markUserChoice(catId);
    this.setState(function (s) {
      var cur = s.sel[catId]; if (!cur) return {};
      var qty = Math.max(1, Math.min(20, (cur.qty || 1) + delta));
      var n = Object.assign({}, s.sel);
      n[catId] = Object.assign({}, cur, { qty: qty });
      return { sel: n };
    });
  };

  BundleConfigurator.prototype.setMontaje = function (id) { this.setState({ montaje: id }); };
  BundleConfigurator.prototype.toggleCat = function (id) {
    this.setState(function (s) {
      var n = Object.assign({}, s.open); n[id] = !n[id]; return { open: n };
    });
  };
  BundleConfigurator.prototype.setColor = function (id) { this.setState({ color: id }); };
  BundleConfigurator.prototype.setSearch = function (catId, v) {
    this.setState(function (s) {
      var n = Object.assign({}, s.search); n[catId] = v; return { search: n };
    });
  };

  BundleConfigurator.prototype.selFactory = function (catId, optId) {
    var self = this;
    if (catId === this.springCatId) this.springManual = true;
    this.markUserChoice(catId);
    this.setState(function (s) {
      var n = Object.assign({}, s.sel);
      n[catId] = { opt: optId, mode: 'factory' };
      self.pruneIfGate(catId, n);
      return { sel: n };
    });
  };

  BundleConfigurator.prototype.selAlt = function (catId) {
    var self = this;
    if (catId === this.springCatId) this.springManual = true;
    this.markUserChoice(catId);
    var c = this.findCat(catId);
    var alt = c && c.opts.find(function (o) { return o.s === 'in' && self.compatible(o, self.state.power); });
    if (alt) {
      this.setState(function (s) {
        var n = Object.assign({}, s.sel); n[catId] = { opt: alt.id, mode: 'in' };
        self.pruneIfGate(catId, n);
        var ns = Object.assign({}, s.search); ns[catId] = '';
        return { sel: n, search: ns };
      });
    }
  };

  BundleConfigurator.prototype.removeSel = function (catId) {
    var self = this;
    if (catId === this.springCatId) this.springManual = true;
    this.markUserChoice(catId);
    this.setState(function (s) {
      var n = Object.assign({}, s.sel); delete n[catId];
      self.pruneIfGate(catId, n);
      return { sel: n };
    });
  };

  // Toggle the "Ver N opciones compatibles" disclosure for a category.
  BundleConfigurator.prototype.toggleRest = function (catId) {
    this.setState(function (s) {
      var n = Object.assign({}, s.restOpen); n[catId] = !n[catId]; return { restOpen: n };
    });
  };

  /* ─── AI search (deterministic keyword) ──────────────────────────────── */

  BundleConfigurator.prototype.aiSearch = function (catId) {
    var self = this;
    var cat = this.findCat(catId); if (!cat) return;
    var q = (this.state.search[catId] || '').trim();
    this.focusChat();
    if (!q) {
      this.pushBot('Escribe en el buscador qué necesitas para ' + cat.name + ' (marca, medida, presupuesto…) y pulsa «Buscar con IA».');
      return;
    }
    this.pushUser('🔎 ' + cat.name + ': ' + q);
    var lo = q.toLowerCase();
    var pool = cat.opts.filter(function (o) { return self.compatible(o, self.state.power); });
    // On chain categories the AI must respect the active cut family (and the
    // gated state before a chamber is chosen) so it never picks a hidden option.
    if (self.isChainCat(cat)) {
      var fam = self.activeCutFamily();
      if (!fam) {
        self.pushBot('Primero elige la cámara de hop arriba; entonces te recomiendo una ' + cat.name + ' compatible.');
        return;
      }
      pool = pool.filter(function (o) { return self.optionVisibleInChain(o, fam); });
    }
    var match = pool.find(function (o) { return o.s === 'in' && (o.t + ' ' + o.br).toLowerCase().indexOf(lo) >= 0; }) ||
                pool.find(function (o) { return (o.t + ' ' + o.br).toLowerCase().indexOf(lo) >= 0; });
    if (/barat|econ[oó]m|presupuesto|ajustad/.test(lo)) {
      var ins = pool.filter(function (o) { return o.s === 'in'; }).sort(function (a, b) { return a.p - b.p; });
      if (ins[0]) match = ins[0];
    }
    if (/precis|premium|top|mejor/.test(lo)) {
      var ins2 = pool.filter(function (o) { return o.s === 'in'; }).sort(function (a, b) { return b.p - a.p; });
      if (ins2[0]) match = ins2[0];
    }
    setTimeout(function () {
      if (match) {
        self.markUserChoice(catId);
        self.setState(function (s) {
          var n = Object.assign({}, s.sel);
          n[catId] = { opt: match.id, mode: match.s === 'oos' ? 'factory' : 'in', qty: 1 };
          self.pruneIfGate(catId, n);
          var ns = Object.assign({}, s.search); ns[catId] = '';
          return { sel: n, search: ns };
        });
        self.pushBot('Para «' + q + '» en ' + cat.name + ' te recomiendo el ' + match.br + ' ' + match.t +
          ' (' + self.fmt(match.p) + '). Lo he añadido a tu build' + (match.s === 'oos' ? ' como pedido a fábrica.' : '.'));
      } else {
        self.pushBot('No encuentro una coincidencia exacta para «' + q + '» en ' + cat.name +
          '. Dime marca, medida o presupuesto y te propongo la mejor opción compatible con ' + self.state.power + '.');
      }
    }, 340);
  };

  /* ─── Chat / questionnaire (ported) ──────────────────────────────────── */

  BundleConfigurator.prototype.pushBot = function (text) {
    this.setState(function (s) { return { aiMsgs: s.aiMsgs.concat([{ who: 'bot', text: text }]) }; });
  };
  BundleConfigurator.prototype.pushUser = function (text) {
    this.setState(function (s) { return { aiMsgs: s.aiMsgs.concat([{ who: 'user', text: text }]) }; });
  };
  BundleConfigurator.prototype.focusChat = function () {
    try {
      var el = this.mount.querySelector('#qa-input');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (el) el.focus();
    } catch (e) {}
  };

  // The questionnaire maps abstract intents onto whatever real categories
  // exist. Because the mock's fixed option ids (b1/h1/t1…) won't match real
  // data, applyAnswer resolves categories by name and picks options by
  // price/stock heuristics. This keeps the panel fully functional on real
  // data while preserving the design's guided behavior.
  BundleConfigurator.prototype.catByName = function (re) {
    return this.P.categories.find(function (c) { return re.test(c.name); });
  };
  // Candidate options for auto-pick (questionnaire). Honors joule compatibility
  // AND, on a cascade chain category, the active cut family + gated state: when
  // the chamber isn't chosen yet the chain has NO candidates (returns []).
  BundleConfigurator.prototype.autoPickCandidates = function (cat) {
    var self = this;
    var opts = cat.opts.filter(function (o) { return self.compatible(o, self.state.power); });
    if (this.isChainCat(cat)) {
      var fam = this.activeCutFamily();
      if (!fam) return [];
      opts = opts.filter(function (o) { return self.optionVisibleInChain(o, fam); });
    }
    return opts;
  };
  BundleConfigurator.prototype.cheapestIn = function (cat) {
    if (!cat) return null;
    var pool = this.autoPickCandidates(cat);
    var ins = pool.filter(function (o) { return o.s === 'in'; }).sort(function (a, b) { return a.p - b.p; });
    return ins[0] || pool[0] || null;
  };
  BundleConfigurator.prototype.dearestIn = function (cat) {
    if (!cat) return null;
    var pool = this.autoPickCandidates(cat);
    var ins = pool.filter(function (o) { return o.s === 'in'; }).sort(function (a, b) { return b.p - a.p; });
    return ins[0] || pool[0] || null;
  };
  BundleConfigurator.prototype.pickInto = function (sel, cat, opt) {
    if (cat && opt) {
      sel[cat.id] = { opt: opt.id, mode: opt.s === 'oos' ? 'factory' : 'in', qty: 1 };
      // Questionnaire picks are user-driven: drop from the star auto-registry so
      // the star pre-selector never overwrites them.
      this.markUserChoice(cat.id);
      // If we just set the cascade gate, prune now so subsequent picks in the
      // same flow see the resolved family (and stale chain picks are dropped).
      if (this.isGateCatId(cat.id)) this.pruneIfGate(cat.id, sel);
    }
  };

  BundleConfigurator.prototype.applyAnswer = function (id, v) {
    var self = this;
    if (id === 'power') { this.setPower(v === 'rec' ? (this.powers[Math.min(2, this.powers.length - 1)] || {}).id || this.state.power : v); return; }
    if (id === 'range') {
      var barrel = this.catByName(/(ca[nñ][oó]n|barrel)/i);
      this.setState(function (s) {
        var sel = Object.assign({}, s.sel);
        var opt = v === 'short' ? self.cheapestIn(barrel) : v === 'long' ? self.dearestIn(barrel) : self.cheapestIn(barrel);
        self.pickInto(sel, barrel, opt);
        return { sel: sel };
      });
      return;
    }
    if (id === 'priority') {
      var hop = this.catByName(/(hop)/i), trig = this.catByName(/(gatillo|trigger)/i), barrel2 = this.catByName(/(ca[nñ][oó]n|barrel)/i);
      this.setState(function (s) {
        var sel = Object.assign({}, s.sel);
        if (v === 'precision') { self.pickInto(sel, hop, self.dearestIn(hop)); self.pickInto(sel, trig, self.dearestIn(trig)); }
        else if (v === 'reliab') { self.pickInto(sel, hop, self.cheapestIn(hop)); self.pickInto(sel, trig, self.dearestIn(trig)); }
        else { self.pickInto(sel, barrel2, self.cheapestIn(barrel2)); self.pickInto(sel, hop, self.cheapestIn(hop)); self.pickInto(sel, trig, self.cheapestIn(trig)); }
        return { sel: sel };
      });
      return;
    }
    if (id === 'finish') {
      var supp = this.catByName(/(silenciador|suppres)/i), stock = this.catByName(/(culata|stock)/i);
      if (v === 'metal') {
        if (this.colors.length) this.setColor((this.colors.find(function (c) { return /negro|black/i.test(c.name); }) || this.colors[0]).id);
        this.setState(function (s) { var sel = Object.assign({}, s.sel); self.pickInto(sel, supp, self.dearestIn(supp)); self.pickInto(sel, stock, self.dearestIn(stock)); return { sel: sel }; });
      } else if (v === 'stealth') {
        if (this.colors.length) this.setColor((this.colors.find(function (c) { return /od|green|verde/i.test(c.name); }) || this.colors[0]).id);
        this.setState(function (s) { var sel = Object.assign({}, s.sel); self.pickInto(sel, supp, self.cheapestIn(supp)); return { sel: sel }; });
      }
      return;
    }
    if (id === 'optics') {
      var scope = this.catByName(/(visor|scope)/i), mount = this.catByName(/(montura|anilla|mount)/i), bipod = this.catByName(/(b[ií]pode|bipod)/i);
      this.setState(function (s) {
        var sel = Object.assign({}, s.sel);
        if (v === 'scope') { self.pickInto(sel, scope, self.cheapestIn(scope)); self.pickInto(sel, mount, self.cheapestIn(mount)); }
        else if (v === 'scopebipod') { self.pickInto(sel, scope, self.cheapestIn(scope)); self.pickInto(sel, mount, self.cheapestIn(mount)); self.pickInto(sel, bipod, self.cheapestIn(bipod)); }
        else { if (scope) delete sel[scope.id]; if (mount) delete sel[mount.id]; if (bipod) delete sel[bipod.id]; }
        return { sel: sel };
      });
      return;
    }
  };

  BundleConfigurator.prototype.answer = function (value) {
    var self = this;
    var flow = this.flow();
    var step = flow[this.state.qaStep]; if (!step) return;
    var opt = step.opts.find(function (o) { return o.v === value; }) || { l: value };
    this.pushUser(opt.l);
    this.applyAnswer(step.id, value);
    var next = this.state.qaStep + 1;
    this.setState({ qaStep: next });
    setTimeout(function () {
      if (next < flow.length) self.pushBot(flow[next].q);
      else self.finishQa();
    }, 340);
  };

  BundleConfigurator.prototype.finishQa = function () {
    var self = this;
    this.setState(function (s) {
      var sel = Object.assign({}, s.sel);
      // Ensure all required categories are filled with a sensible default.
      self.P.categories.forEach(function (cat) {
        if (cat.req && !sel[cat.id]) {
          var opt = self.cheapestIn(cat);
          self.pickInto(sel, cat, opt);
        }
      });
      // Auto spring if available.
      if (self.springCatId && !sel[self.springCatId]) {
        var sp = self.recSpring();
        if (sp) { var o = self.findOpt(self.springCatId, sp); sel[self.springCatId] = { opt: sp, mode: o.s === 'oos' ? 'factory' : 'in' }; }
      }
      return { sel: sel };
    });
    setTimeout(function () {
      var T = self.totals(); var d = Math.round(T.tier * 100);
      self.pushBot('¡Listo! Te he montado tu ' + self.P.name + ' a ' + self.state.power + ': ' + T.count +
        ' componentes, total ' + self.eur(T.total) + (d > 0 ? (' con ' + d + '% de descuento') : '') + '. Revísalo abajo y ajusta lo que quieras.');
    }, 80);
  };

  BundleConfigurator.prototype.resetQa = function () {
    var self = this;
    this.springManual = false;
    this._autoSel = {};
    var flow = this.flow();
    // Reset power/color RAW first so the star pre-selector (which reads
    // this.state.power for compatibility) sees the reset values, then rebuild
    // the recommended pre-filled selection on a fresh map — same as load().
    this.setStateRaw({
      sel: {},
      power: this.powers.length ? (this.powers[Math.min(2, this.powers.length - 1)].id) : this.state.power,
      color: this.colors.length ? this.colors[0].id : this.state.color
    });
    this.preselectStars(this.state.sel);
    this.setState({
      qaStep: 0, qaInput: '',
      aiMsgs: this.powers.length
        ? [{ who: 'bot', text: this.GREETING }, { who: 'bot', text: flow[0].q }]
        : [{ who: 'bot', text: this.GREETING }]
    });
  };

  BundleConfigurator.prototype.autoConfigure = function () {
    var self = this;
    this.springManual = true;
    this.pushUser('Móntalo tú, build competitivo');
    this.setState(function (s) {
      var sel = Object.assign({}, s.sel);
      // Fill required + a few common categories with cheapest in-stock.
      self.P.categories.forEach(function (cat) {
        if (cat.req || /goma|bucking|silenciador|suppres/i.test(cat.name)) {
          var opt = self.cheapestIn(cat);
          if (opt) self.pickInto(sel, cat, opt);
        }
      });
      return { sel: sel, qaStep: self.flow().length };
    });
    setTimeout(function () {
      var T = self.totals();
      self.pushBot('He montado un build competitivo a ' + self.state.power + ': ' + T.count + ' piezas → total ' + self.eur(T.total) + '.');
    }, 360);
  };

  BundleConfigurator.prototype.qaSend = function () {
    var self = this;
    var txt = (this.state.qaInput || '').trim(); if (!txt) return;
    this.setState({ qaInput: '' });
    this.pushUser(txt);
    var lo = txt.toLowerCase();
    if (/monta|config[uú]ra|hazlo|todo|complet|recomi[eé]nda|recomiend/.test(lo)) { this.autoConfigure(); return; }
    var did = [];
    ['1.3', '1.9', '2.3', '2.8', '3.0'].forEach(function (j) {
      if (lo.indexOf(j) >= 0) { self.setPower(j + 'J'); did.push('potencia ' + j + 'J'); }
    });
    if (/cqb|corto|corta|manejable/.test(lo)) { this.applyAnswer('range', 'short'); did.push('cañón corto'); }
    else if (/largo|alcance|distancia|sniper/.test(lo)) { this.applyAnswer('range', 'long'); did.push('largo alcance'); }
    if (/precis|agrupa|tiro/.test(lo)) { this.applyAnswer('priority', 'precision'); did.push('precisión'); }
    if (/barat|econ[oó]m|presupuesto|ajustad/.test(lo)) { this.applyAnswer('priority', 'budget'); did.push('presupuesto ajustado'); }
    if (/metal|premium|aluminio|cnc/.test(lo)) { this.applyAnswer('finish', 'metal'); did.push('acabado premium'); }
    if (/discret|silenci|sigil|stealth/.test(lo)) { this.applyAnswer('finish', 'stealth'); did.push('discreto'); }
    if (/b[ií]pode|bipod/.test(lo)) { this.applyAnswer('optics', 'scopebipod'); did.push('óptica + bípode'); }
    else if (/visor|mira|[oó]ptica|scope/.test(lo)) { this.applyAnswer('optics', 'scope'); did.push('óptica'); }
    var reply = did.length
      ? ('Hecho: ' + did.join(', ') + '. ¿Algo más? Puedes seguir con las opciones de arriba o pedirme otra cosa.')
      : 'Cuéntame algo más concreto: potencia (p.ej. 2.3J), alcance (corto/largo), precisión, acabado o si quieres óptica. O usa las opciones de arriba 👇';
    setTimeout(function () { self.pushBot(reply); }, 320);
  };

  /* ─── ADD TO CART (NET-NEW) — configure → cart → /cart/add.js ────────── */

  BundleConfigurator.prototype.buildSelections = function () {
    var self = this;
    var sels = [];
    Object.keys(this.state.sel).forEach(function (cid) {
      var sel = self.state.sel[cid];
      var o = self.findOpt(cid, sel.opt);
      if (!o) return;
      sels.push({
        partOptionId: o.id,
        categoryId: cid,
        price: o.p,
        quantity: sel.qty || 1,
        mode: sel.mode || 'in',
        variantId: o.variantId != null ? o.variantId : undefined
      });
    });
    return sels;
  };

  BundleConfigurator.prototype.addToCart = function () {
    var self = this;
    if (this._adding) return;
    var missing = this.P.categories.filter(function (c) { return c.req && !self.state.sel[c.id]; });
    if (missing.length) return; // CTA disabled anyway

    this._adding = true;
    this.setState({ cartError: '' });
    this.setAddBusy(true);

    var selections = this.buildSelections();
    var T = this.totals();
    var montDef = MONTAJE.find(function (m) { return m.id === self.state.montaje; }) || MONTAJE[0];

    // 1) configure → bundleKey
    fetch(this.apiBase + '/configure', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ platformId: this.platformId, selections: selections, power: this.state.power, color: this.state.color })
    })
      .then(function (r) { if (!r.ok) throw new Error('configure ' + r.status); return r.json(); })
      .then(function (cfg) {
        var bundleKey = cfg && cfg.bundleKey;
        // 2) cart → line items
        return fetch(self.apiBase + '/cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ bundleKey: bundleKey, platformId: self.platformId, selections: selections })
        }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
          .then(function (cartResp) { return { bundleKey: bundleKey, items: (cartResp && cartResp.items) || [] }; });
      })
      .then(function (res) {
        var items = res.items;
        if (!items.length) throw new Error('No cart items returned');

        // Attach montaje + meta as line-item property note on the FIRST item.
        // No real montaje product is wired — captured as a property only.
        if (!items[0].properties) items[0].properties = {};
        if (self.state.montaje !== 'none') {
          items[0].properties['_bundle_montaje'] = montDef.name + ' (+' + self.fmt(montDef.price) + ')';
        }
        items[0].properties['_bundle_power'] = self.state.power || '';
        if (self.state.color) items[0].properties['_bundle_color'] = self.state.color;
        if (res.bundleKey) items[0].properties['_bundle_key'] = res.bundleKey;

        // Normalize to Shopify /cart/add.js item shape: { id, quantity, properties }
        var addItems = items.map(function (it) {
          return {
            id: it.id != null ? it.id : it.variantId,
            quantity: it.quantity || 1,
            properties: it.properties || undefined
          };
        });

        // 3) Shopify /cart/add.js
        var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: addItems })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
      })
      .then(function (out) {
        if (!out.ok || out.data.status) {
          throw new Error(out.data.description || out.data.message || 'No se pudo añadir al carrito');
        }
        self.onCartSuccess(out.data);
      })
      .catch(function (e) {
        if (window.console) console.error('[bundle-configurator] add-to-cart error:', e);
        self.setAddBusy(false);
        self._adding = false;
        self.setState({ cartError: 'No se pudo añadir el build al carrito. Inténtalo de nuevo.' });
      });
  };

  BundleConfigurator.prototype.onCartSuccess = function () {
    var self = this;
    this._adding = false;
    this.setAddBusy(false);

    // Refresh + open the cart drawer using the theme's own mechanism. Falls
    // back to a redirect to /cart when no drawer is present.
    var drawer = document.querySelector('cart-drawer');
    var refreshed = false;
    try {
      // Notify theme listeners (mini-cart sections subscribe to cart:refresh).
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true, detail: { open: true }
      }));
      refreshed = true;
    } catch (e) {}
    try {
      if (window.theme && window.theme.pubsub) {
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-configurator' });
      }
    } catch (e) {}

    if (drawer && typeof drawer.show === 'function') {
      try { drawer.show(); refreshed = true; } catch (e) {}
    }
    if (!refreshed) {
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart' : '/cart';
      window.location.href = cartUrl;
    }
  };

  BundleConfigurator.prototype.setAddBusy = function (busy) {
    var btns = this.mount.querySelectorAll('[data-act="add"]');
    btns.forEach(function (b) {
      if (busy) { b.setAttribute('aria-busy', 'true'); b.setAttribute('disabled', 'disabled'); }
      else { b.removeAttribute('aria-busy'); b.removeAttribute('disabled'); }
    });
  };

  /* ─── Animated "desde" counter ───────────────────────────────────────── */

  BundleConfigurator.prototype.afterRender = function () {
    var self = this;
    // Keep chat scrolled to bottom.
    try { var el = this.mount.querySelector('#qa-msgs'); if (el) el.scrollTop = el.scrollHeight; } catch (e) {}

    var t = this.totals().total;
    if (this._target === null) { this._target = t; this._disp = t; this.paintDesde(); return; }
    if (Math.abs(t - this._target) > 0.005) {
      this._target = t;
      if (this._iv) clearInterval(this._iv);
      var from = this._disp, dur = 420, t0 = Date.now();
      this._iv = setInterval(function () {
        var k = Math.min(1, (Date.now() - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        self._disp = from + (t - from) * e;
        self.paintDesde();
        if (k >= 1) { clearInterval(self._iv); self._iv = null; }
      }, 16);
    }
  };

  BundleConfigurator.prototype.paintDesde = function () {
    var label = this.eur(this._disp);
    var nodes = this.mount.querySelectorAll('[data-desde]');
    nodes.forEach(function (n) { n.textContent = label; });
  };

  /* ─── RENDER ─────────────────────────────────────────────────────────── */

  BundleConfigurator.prototype.renderState = function (kind, html) {
    this.mount.innerHTML = '<div class="cfg-root" data-theme="' + ((this.state && this.state.theme === 'dark') ? 'dark' : 'light') + '"><div class="cfg-state ' +
      (kind === 'error' ? 'cfg-state--error' : '') + '">' + html + '</div></div>';
  };

  // computeView mirrors the DC renderVals(): it derives all display props.
  BundleConfigurator.prototype.computeView = function () {
    var self = this, S = this.state, T = this.totals();

    var colorObj = this.colors.find(function (c) { return c.id === S.color; });
    var recSpring = this.recSpring();

    // powers
    var powers = this.powers.map(function (p) {
      return { id: p.id, julios: p.julios, fps: p.fps, on: p.id === S.power };
    });

    // categories (gasOnly filtering removed — only real categories)
    var stockMeta = function (s) {
      if (s === 'in') return { text: 'EN STOCK', cls: 'in' };
      if (s === 'pre') return { text: 'PREORDER', cls: 'pre' };
      return { text: 'SIN STOCK', cls: 'oos' };
    };

    // Cascade: active cut family (null when no cascade / no chamber chosen).
    var cutFamily = this.activeCutFamily();

    var categories = this.P.categories
      .filter(function (c) { return c.categoryKind !== 'power' && c.categoryKind !== 'color'; })
      .map(function (cat) {
        var sel = S.sel[cat.id];
        var isOpen = !!S.open[cat.id];
        var q = (S.search[cat.id] || '').toLowerCase();
        var hasComp = cat.opts.some(function (o) { return o.comp && o.comp.length; });

        // Cascade chain category: gated until the chamber is chosen, then
        // filtered by the active cut family (untagged options stay visible).
        var isChain = self.isChainCat(cat);
        var cascadeGated = isChain && !cutFamily;
        var opts = cat.opts.filter(function (o) { return self.compatible(o, S.power); });
        if (isChain && cutFamily) {
          opts = opts.filter(function (o) { return self.optionVisibleInChain(o, cutFamily); });
        }
        var visTotal = opts.length;
        // Visible/compatible set BEFORE the search filter — the star is picked
        // from this so it stays stable while the customer types in the filter.
        var visibleForStar = opts.slice();
        if (cat.search && q) opts = opts.filter(function (o) { return (o.t + ' ' + o.br).toLowerCase().indexOf(q) >= 0; });

        var chosen = cat.req ? 'Elige 1 · obligatorio' : 'Opcional · sin selección';
        if (cascadeGated) chosen = CASCADE_GATE_NOTE;
        if (sel) { var so = self.findOpt(cat.id, sel.opt); chosen = (sel.mode === 'factory' ? '★ Pedido a fábrica · ' : '✓ ') + (so ? so.t : ''); }

        // STAR: the single recommended option among the visible/compatible set.
        var starRaw = cascadeGated ? null : self.pickStar(visibleForStar);

        // Build an option view object (shared by the star card + rest cards).
        var optView = function (o) {
          var m = stockMeta(o.s);
          var isSel = !!(sel && sel.opt === o.id);
          var isOOS = o.s === 'oos';
          var factorySel = isSel && sel.mode === 'factory';
          var qtyEnabled = !!cat.qtyEnabled;
          var qty = isSel ? (sel.qty || 1) : 1;
          return {
            id: o.id, brand: o.br, title: o.t, priceLabel: self.fmt(o.p),
            imageUrl: o.imageUrl,
            stockText: m.text, stockCls: m.cls,
            lowShow: !!o.low && !isOOS,
            isSelected: isSel, isOOS: isOOS, factorySel: factorySel,
            recShow: (cat.id === self.springCatId && o.id === recSpring),
            pillShow: !isOOS && !(qtyEnabled && isSel),
            qtyShow: qtyEnabled && isSel && !isOOS,
            qty: qty, qtyLabel: qty + ' ud · ' + self.fmt(o.p * qty),
            lead: '1–2 sem'
          };
        };

        // Star view + reason line. The star is pinned at the top and is NOT
        // subject to the search filter; the REST (non-star) options are.
        var starView = null;
        if (starRaw) {
          starView = optView(starRaw);
          starView.reason = self.starReason(cat, starRaw, visibleForStar);
        }
        var restRaw = cascadeGated ? [] : opts.filter(function (o) { return !starRaw || o.id !== starRaw.id; });
        var restOptions = restRaw.map(optView);
        var restOpen = !!S.restOpen[cat.id];
        var restCount = restOptions.length;

        return {
          id: cat.id, name: cat.name, requiredShow: cat.req, optionalShow: !cat.req,
          countLabel: cat.count + ' opciones', chosenLabel: chosen, isOpen: isOpen,
          dotState: sel ? 'sel' : (cascadeGated ? 'opt' : (cat.req ? 'req' : 'opt')),
          hasSearch: !!cat.search && !cascadeGated, searchValue: S.search[cat.id] || '',
          shownLabel: 'Mostrando ' + opts.length + ' de ' + cat.count,
          powerNoteShow: hasComp && !cascadeGated,
          powerNote: 'Mostrando ' + visTotal + ' compatible' + (visTotal === 1 ? '' : 's') + ' con ' + S.power,
          // Cascade gated-state (chain category before chamber is chosen).
          cascadeGated: cascadeGated,
          cascadeGateNote: CASCADE_GATE_NOTE,
          // STAR recommendation block.
          star: starView,
          restOptions: restOptions,
          restCount: restCount,
          restOpen: restOpen,
          restToggleLabel: restOpen ? 'Ocultar' : ('Ver ' + restCount + (restCount === 1 ? ' opción compatible' : ' opciones compatibles')),
          restToggleCaret: restOpen ? '▴' : '▾',
          // No visible options at all (after search) → empty-state copy.
          noneShown: !cascadeGated && !starView && !restOptions.length
        };
      });

    // summary items
    var montName = MONTAJE_NAME[S.montaje];
    var summaryItems = [];
    this.P.categories.forEach(function (cat) {
      var sel = S.sel[cat.id]; if (!sel) return;
      var o = self.findOpt(cat.id, sel.opt); if (!o) return;
      var factory = sel.mode === 'factory';
      var qty = sel.qty || 1;
      summaryItems.push({
        catId: cat.id, catName: cat.name, optTitle: o.t + (qty > 1 ? (' ×' + qty) : ''),
        priceLabel: self.fmt(o.p * qty), dot: factory ? 'factory' : 'in',
        flagShow: factory, flag: 'PEDIDO A FÁBRICA · 1–2 SEM', flagCls: 'factory',
        removeAct: { act: 'remove', cat: cat.id }
      });
    });
    if (S.montaje !== 'none') {
      summaryItems.push({
        catId: '__montaje__', catName: 'Servicio', optTitle: montName, priceLabel: '+' + self.fmt(T.montCost),
        dot: 'service', flagShow: S.montaje === 'prem', flag: '2 MANT./AÑO · 2 AÑOS · RENOVABLE', flagCls: 'service',
        removeAct: { act: 'mont', mont: 'none' }
      });
    }

    // tier copy
    var count = T.count;
    var tierMsg;
    if (count < 2) { tierMsg = 'Añade ' + (2 - count) + ' pieza' + (2 - count > 1 ? 's' : '') + ' y ahorra 2%'; }
    else if (count < 3) { tierMsg = 'Añade 1 pieza más y ahorra 5%'; }
    else if (count < 5) { tierMsg = 'Añade ' + (5 - count) + ' pieza' + (5 - count > 1 ? 's' : '') + ' más y ahorra 7%'; }
    else { tierMsg = '✓ Descuento máximo aplicado · 7%'; }
    var tierPct = Math.min(100, (count / 5) * 100);
    var discPct = Math.round(T.tier * 100);

    // cta
    var missing = this.P.categories.filter(function (c) { return c.req && !S.sel[c.id]; });
    var canAdd = missing.length === 0 && count > 0;
    var addLabel = canAdd ? ('Añadir build al carrito · ' + this.eur(T.total))
      : (count === 0 ? 'Elige tus componentes' : ('Faltan ' + missing.length + ' componente' + (missing.length > 1 ? 's' : '') + ' obligatorio' + (missing.length > 1 ? 's' : '')));
    var addLabelShort = canAdd ? 'Añadir al carrito' : (missing.length ? ('Faltan ' + missing.length) : 'Elige piezas');
    var missingMsg = canAdd ? '' : (missing.length ? ('Por elegir: ' + missing.map(function (c) { return c.name; }).join(', ')) : '');

    var pdat = this.powers.find(function (p) { return p.id === S.power; }) || {};
    var colName = colorObj ? colorObj.name : '';
    var summaryLine = (S.power || '') + (pdat.fps ? (' (' + pdat.fps + ' FPS)') : '') +
      (colName ? ('  ·  ' + colName) : '') + '  ·  ' + count + ' componente' + (count === 1 ? '' : 's');

    // chat
    var flow = this.flow();
    var qaStep = flow[S.qaStep];
    var qaHasChips = !!qaStep && this.powers.length > 0;
    var qaOpts;
    if (qaStep && this.powers.length) { qaOpts = qaStep.opts.map(function (o) { return { text: o.l, v: o.v }; }); }
    else { qaOpts = [{ text: '↺ Empezar de nuevo', reset: true }, { text: '⚡ Build competitivo', auto: true }]; }

    var montOpts = MONTAJE.map(function (mo) {
      return {
        id: mo.id, name: mo.name, desc: mo.desc, perks: mo.perks || [],
        badge: mo.badge || '', badgeShow: !!mo.badge,
        priceLabel: mo.price > 0 ? ('+' + self.eur(mo.price)) : 'Incluido gratis',
        on: S.montaje === mo.id
      };
    });

    return {
      light: S.theme === 'light',
      themeIcon: S.theme === 'light' ? '☾' : '☀',
      platformName: this.P.name, platformBrand: this.P.brand,
      hasBase: this.P.hasBase, basePriceLabel: this.eur(this.P.base),
      desdeBig: this.eur(this._disp),
      heroColorName: colName,
      summaryLine: summaryLine,
      powers: powers, colors: this.colors, color: S.color,
      categories: categories,
      chosenCountLabel: count + ' de ' + categories.length + ' elegidos',
      montOpts: montOpts, montShow: T.montCost > 0, montLabel: montName, montCostLabel: this.fmt(T.montCost),
      summaryItems: summaryItems, emptyShow: summaryItems.length === 0,
      partsCountLabel: count + ' pieza' + (count === 1 ? '' : 's'),
      partsSubtotalLabel: this.fmt(T.parts),
      discountShow: discPct > 0, discPct: discPct, discAmountLabel: this.fmt(T.disc),
      totalLabel: this.eur(T.total),
      tierMsg: tierMsg, tierPct: tierPct,
      canAdd: canAdd, addLabel: addLabel, addLabelShort: addLabelShort,
      missingShow: !canAdd && count > 0 && missing.length > 0, missingMsg: missingMsg,
      cartError: S.cartError,
      sheetOpen: S.sheet, sheetCaret: S.sheet ? '▾' : '▴',
      aiMsgs: S.aiMsgs, qaHasChips: qaHasChips, qaOpts: qaOpts, qaInputValue: S.qaInput
    };
  };

  // HTML builders. We keep the design's inline styles (driven by CSS vars) for
  // fidelity; data-act / data-cat / data-opt attributes drive event delegation.
  BundleConfigurator.prototype.render = function () {
    if (!this.P) return;
    var self = this;
    var V = this.computeView();
    var H = [];

    H.push('<div class="cfg-root" data-theme="' + (V.light ? 'light' : 'dark') + '" style="min-height:100vh;background:var(--bg);color:var(--text);font-family:\'Archivo\',system-ui,sans-serif;padding-bottom:90px;transition:background-color .3s ease,color .3s ease">');

    /* HEADER */
    H.push('<div style="position:sticky;top:0;z-index:40;background:var(--header-bg);backdrop-filter:blur(12px);border-bottom:1px solid var(--border)">');
    H.push('<div class="cfg-pad" style="max-width:1320px;margin:0 auto;padding:0 28px;height:60px;display:flex;align-items:center;justify-content:space-between;gap:16px">');
    H.push('<div style="display:flex;align-items:center;gap:18px;min-width:0">');
    H.push('<div style="font:700 19px \'Oswald\',sans-serif;letter-spacing:1.5px;text-transform:uppercase">SKIRM<span style="color:var(--accent)">SHOP</span></div>');
    H.push('<div style="height:18px;width:1px;background:var(--border-3)"></div>');
    H.push('<div style="font-size:12px;color:var(--muted);letter-spacing:.3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">Inicio<span style="margin:0 7px;opacity:.5">/</span>' + esc(V.platformBrand || '') + '<span style="margin:0 7px;opacity:.5">/</span><span style="color:var(--text)">Configura tu upgrade</span></div>');
    H.push('</div>');
    H.push('<div style="display:flex;align-items:center;gap:12px">');
    H.push('<button type="button" data-act="theme" class="cfg-hoverable" title="Cambiar tema" aria-label="Cambiar tema" style="cursor:pointer;width:36px;height:36px;border-radius:9px;background:transparent;border:1px solid var(--border-2);color:var(--muted);font-size:15px;display:flex;align-items:center;justify-content:center">' + V.themeIcon + '</button>');
    H.push('<div style="display:flex;align-items:center;gap:6px;font-size:11px;font-weight:600;letter-spacing:.5px;color:var(--text);border:1px solid var(--border-2);border-radius:20px;padding:5px 11px"><span style="width:7px;height:7px;border-radius:50%;background:var(--accent)"></span>+18 AIRSOFT</div>');
    H.push('<button type="button" data-act="focuschat" style="cursor:pointer;display:flex;align-items:center;gap:8px;background:transparent;border:1px solid var(--accent);color:var(--accent);font:600 12px \'Archivo\',sans-serif;letter-spacing:.5px;padding:8px 14px;border-radius:8px;transition:.18s">★ ASISTENTE IA</button>');
    H.push('</div></div></div>');

    /* HERO */
    H.push('<div class="cfg-pad" style="max-width:1320px;margin:0 auto;padding:28px">');
    H.push('<div class="cfg-hero" style="display:grid;grid-template-columns:1.05fr 1fr;gap:28px;align-items:stretch">');

    // rifle photo
    H.push('<div style="position:relative;border:1px solid var(--border);border-radius:16px;overflow:hidden;min-height:420px;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,rgba(255,90,31,0.10),#121212 60%),repeating-linear-gradient(45deg,#191919 0 16px,#1e1e1e 16px 32px)">');
    H.push('<div style="position:absolute;top:16px;left:16px;display:flex;gap:8px">');
    H.push('<div style="font:600 10px \'Archivo\',sans-serif;letter-spacing:1.5px;color:#171717;background:var(--accent);padding:5px 10px;border-radius:6px">' + esc((V.platformBrand || 'BUILD').toUpperCase()) + '</div>');
    if (V.heroColorName) H.push('<div style="font:600 10px \'Archivo\',sans-serif;letter-spacing:1px;color:#e8e8e8;background:rgba(0,0,0,0.45);border:1px solid rgba(255,255,255,0.18);padding:5px 10px;border-radius:6px">COLOR · ' + esc(V.heroColorName) + '</div>');
    H.push('</div>');
    H.push('<div style="font-family:\'Oswald\',sans-serif;font-size:13px;letter-spacing:3px;color:rgba(255,255,255,0.34);text-transform:uppercase">[ ' + esc(V.platformName) + ' ]</div>');
    H.push('<div style="position:absolute;bottom:16px;right:16px;display:flex;align-items:center;gap:7px;font:600 10px \'Archivo\',sans-serif;letter-spacing:1px;color:#bdbdbd;background:rgba(0,0,0,0.45);border:1px solid rgba(255,255,255,0.18);padding:6px 11px;border-radius:20px">⊕ VISOR 3D PRÓXIMAMENTE</div>');
    H.push('<div style="position:absolute;bottom:16px;left:16px;font:500 10px \'Archivo\',sans-serif;letter-spacing:.5px;color:#9a9a9a">Recogida en tienda · listo en 24 h</div>');
    H.push('</div>');

    // config head
    H.push('<div style="display:flex;flex-direction:column">');
    H.push('<div style="font:600 11px \'Archivo\',sans-serif;letter-spacing:2.5px;color:var(--accent);text-transform:uppercase;margin-bottom:8px">Configurador de upgrade</div>');
    H.push('<h1 style="font:600 38px/1.02 \'Oswald\',sans-serif;letter-spacing:.5px;text-transform:uppercase;margin:0 0 6px">' + esc(V.platformName) + '</h1>');
    H.push('<div style="font-size:13px;color:var(--muted);margin-bottom:16px">' + esc(V.platformBrand || '') + '</div>');

    // AI questionnaire
    H.push(this.renderChat(V));

    // price
    if (V.hasBase) {
      H.push('<div style="display:flex;align-items:baseline;gap:16px;padding:18px 0 0;margin-top:18px;border-top:1px solid var(--border)">');
      H.push('<div><div style="font-size:10px;letter-spacing:1.5px;color:var(--muted-2);text-transform:uppercase">Precio base</div><div style="font:500 16px \'Oswald\',sans-serif;color:var(--muted)">' + esc(V.basePriceLabel) + '</div></div>');
      H.push('<div style="margin-left:auto;text-align:right"><div style="font-size:10px;letter-spacing:1.5px;color:var(--muted-2);text-transform:uppercase">Tu build · DESDE</div><div data-desde style="font:700 30px \'Oswald\',sans-serif;color:var(--accent);line-height:1.05">' + esc(V.desdeBig) + '</div></div>');
      H.push('</div>');
    } else {
      H.push('<div style="display:flex;align-items:baseline;gap:16px;padding:18px 0 0;margin-top:18px;border-top:1px solid var(--border)">');
      H.push('<div style="margin-left:auto;text-align:right"><div style="font-size:10px;letter-spacing:1.5px;color:var(--muted-2);text-transform:uppercase">Tu build · DESDE</div><div data-desde style="font:700 30px \'Oswald\',sans-serif;color:var(--accent);line-height:1.05">' + esc(V.desdeBig) + '</div></div>');
      H.push('</div>');
    }

    // power selector (only when powers exist)
    if (V.powers.length) {
      H.push('<div style="margin-top:18px">');
      H.push('<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px"><div style="font:600 13px \'Archivo\',sans-serif;letter-spacing:.5px">Potencia <span style="color:var(--muted-2);font-weight:400">· FPS / Julios</span></div><div style="font-size:11px;color:var(--muted)">Límite de campo</div></div>');
      H.push('<div class="cfg-powgrid" style="display:grid;grid-template-columns:repeat(' + Math.min(5, V.powers.length) + ',1fr);gap:7px">');
      V.powers.forEach(function (p) {
        var on = p.on;
        H.push('<button type="button" data-act="power" data-power="' + escAttr(p.id) + '" aria-pressed="' + (on ? 'true' : 'false') + '" style="background:none;border:none;padding:0;cursor:pointer">');
        H.push('<div style="cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:2px;padding:11px 4px;border-radius:10px;transition:.15s;background:' + (on ? 'var(--accent-soft, rgba(255,90,31,0.13))' : 'var(--surface-3)') + ';border:1px solid ' + (on ? 'var(--accent)' : 'var(--border-2)') + ';color:' + (on ? 'var(--text-strong)' : 'var(--text)') + ';box-shadow:' + (on ? '0 0 0 1px var(--accent)' : 'none') + '">');
        H.push('<span style="font:600 17px \'Oswald\',sans-serif;letter-spacing:.5px">' + esc(p.julios) + '</span>');
        H.push('<span style="font-size:9px;letter-spacing:.5px;color:var(--muted)">' + esc(p.fps || '') + (p.fps ? ' FPS' : '') + '</span>');
        H.push('</div></button>');
      });
      H.push('</div></div>');
    }

    // color (only when color data exists)
    if (V.colors.length) {
      H.push('<div style="margin-top:18px"><div style="font:600 13px \'Archivo\',sans-serif;letter-spacing:.5px;margin-bottom:10px">Acabado</div><div style="display:flex;gap:10px">');
      V.colors.forEach(function (c) {
        var on = c.id === V.color;
        H.push('<button type="button" data-act="color" data-color="' + escAttr(c.id) + '" title="' + escAttr(c.name) + '" aria-label="' + escAttr(c.name) + '" aria-pressed="' + (on ? 'true' : 'false') + '" style="background:none;border:none;padding:0;cursor:pointer">');
        H.push('<span style="cursor:pointer;width:42px;height:42px;border-radius:11px;padding:0;display:flex;align-items:center;justify-content:center;background:transparent;border:1px solid ' + (on ? 'var(--accent)' : 'var(--border-2)') + ';box-shadow:' + (on ? '0 0 0 1px var(--accent)' : 'none') + ';transition:.15s"><span style="display:block;width:28px;height:28px;border-radius:7px;background:' + esc(c.hex) + ';border:1px solid rgba(0,0,0,0.25)"></span></span>');
        H.push('</button>');
      });
      H.push('</div></div>');
    }

    H.push('</div>'); // config head
    H.push('</div>'); // cfg-hero

    // summary strip
    H.push('<div style="margin-top:18px;display:flex;flex-wrap:wrap;align-items:center;gap:10px;font-size:12px;color:var(--muted);border:1px solid var(--border);border-radius:10px;padding:12px 16px;background:var(--surface)"><span style="color:var(--muted-2);letter-spacing:1px;font-size:10px;text-transform:uppercase">Tu build</span><span style="color:var(--text)">' + esc(V.summaryLine) + '</span></div>');
    H.push('</div>'); // hero pad

    /* MAIN */
    H.push('<div class="cfg-pad cfg-main" style="max-width:1320px;margin:0 auto;padding:8px 28px 40px;display:grid;grid-template-columns:1fr 380px;gap:28px;align-items:start">');

    // categories column
    H.push('<div style="display:flex;flex-direction:column;gap:14px">');
    H.push('<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:2px"><h2 style="font:600 16px \'Oswald\',sans-serif;letter-spacing:1.5px;text-transform:uppercase;margin:0">Componentes</h2><div style="font-size:11px;color:var(--muted)">' + esc(V.chosenCountLabel) + '</div></div>');

    if (!V.categories.length) {
      H.push('<div class="cfg-state" style="border:1px dashed var(--border-2);border-radius:12px">No hay componentes disponibles para esta plataforma todavía.</div>');
    }
    V.categories.forEach(function (cat) { H.push(self.renderCategory(cat)); });

    // MONTAJE
    H.push(this.renderMontaje(V));

    // trust note
    H.push('<div style="display:flex;gap:14px;margin-top:6px;padding:16px 18px;border:1px dashed var(--border-2);border-radius:12px;font-size:11px;color:var(--muted);line-height:1.5"><span style="font-size:18px">⚠</span><div>Producto +18. Los upgrades de fábrica se montan a medida bajo pedido: <strong style="color:var(--text);font-weight:600">no admiten devolución</strong> una vez iniciado el montaje. Las potencias superiores a 2.3J pueden estar limitadas según el reglamento de tu campo.</div></div>');
    H.push('</div>'); // categories column

    // desktop summary
    H.push(this.renderSummary(V));

    H.push('</div>'); // cfg-main

    // mobile bar
    H.push(this.renderMobileBar(V));

    H.push('</div>'); // cfg-root

    this.mount.innerHTML = H.join('');
    if (!this._bound) this.bind();
  };

  BundleConfigurator.prototype.renderChat = function (V) {
    var self = this;
    var H = [];
    H.push('<div style="border:1px solid var(--border-2);border-radius:14px;background:var(--surface);overflow:hidden;display:flex;flex-direction:column;box-shadow:0 6px 22px rgba(0,0,0,0.18)">');
    H.push('<div style="display:flex;align-items:center;gap:10px;padding:11px 14px;border-bottom:1px solid var(--border)">');
    H.push('<div style="width:30px;height:30px;border-radius:9px;background:linear-gradient(135deg,var(--accent),var(--accent-2));display:flex;align-items:center;justify-content:center;font-size:15px">🐾</div>');
    H.push('<div style="flex:1;min-width:0"><div style="font:600 13px \'Oswald\',sans-serif;letter-spacing:1px;text-transform:uppercase">OpenClaw</div><div style="font-size:10px;color:var(--green);display:flex;align-items:center;gap:5px"><span style="width:6px;height:6px;border-radius:50%;background:var(--green)"></span>Configuración guiada por IA</div></div>');
    H.push('<button type="button" data-act="resetqa" class="cfg-hoverable" title="Empezar de nuevo" aria-label="Empezar de nuevo" style="cursor:pointer;width:28px;height:28px;border-radius:7px;background:transparent;border:1px solid var(--border-2);color:var(--muted);font-size:13px">↺</button>');
    H.push('</div>');

    // messages
    H.push('<div id="qa-msgs" style="max-height:188px;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px">');
    V.aiMsgs.forEach(function (m) {
      var bot = m.who === 'bot';
      H.push('<div style="display:flex;justify-content:' + (bot ? 'flex-start' : 'flex-end') + '"><div style="max-width:88%;font:400 12.5px/1.5 \'Archivo\',sans-serif;padding:10px 13px;border-radius:' + (bot ? '4px 12px 12px 12px' : '12px 12px 4px 12px') + ';background:' + (bot ? 'var(--surface-3)' : 'var(--accent-soft, rgba(255,90,31,0.13))') + ';border:1px solid ' + (bot ? 'var(--border)' : 'var(--accent)') + ';color:' + (bot ? 'var(--text)' : 'var(--accent)') + '">' + esc(m.text) + '</div></div>');
    });
    H.push('</div>');

    // chips
    if (V.qaHasChips || V.qaOpts.length) {
      H.push('<div style="display:flex;flex-wrap:wrap;gap:7px;padding:2px 14px 12px">');
      V.qaOpts.forEach(function (chip) {
        var attrs = chip.v != null ? (' data-act="answer" data-v="' + escAttr(chip.v) + '"')
          : chip.reset ? ' data-act="resetqa"' : chip.auto ? ' data-act="autoconf"' : '';
        H.push('<button type="button"' + attrs + ' class="cfg-hoverable" style="cursor:pointer;background:var(--surface-3);border:1px solid var(--border-2);color:var(--text);font:500 12px \'Archivo\',sans-serif;padding:7px 11px;border-radius:18px">' + esc(chip.text) + '</button>');
      });
      H.push('</div>');
    }

    // input
    H.push('<div style="display:flex;gap:8px;padding:11px 14px;border-top:1px solid var(--border)">');
    H.push('<input id="qa-input" type="text" value="' + escAttr(V.qaInputValue) + '" placeholder="Dime qué quieres…" aria-label="Mensaje para el asistente" style="flex:1;min-width:0;background:var(--surface-3);border:1px solid var(--border-2);border-radius:9px;color:var(--text);font:400 13px \'Archivo\',sans-serif;padding:10px 13px;outline:none"/>');
    H.push('<button type="button" data-act="qasend" class="cfg-grad-btn" aria-label="Enviar" style="cursor:pointer;flex-shrink:0;width:42px;background:linear-gradient(135deg,var(--accent),var(--accent-2));border:none;color:#171717;font-size:15px;border-radius:9px;transition:.15s">➤</button>');
    H.push('</div>');
    H.push('</div>');
    return H.join('');
  };

  BundleConfigurator.prototype.renderCategory = function (cat) {
    var H = [];
    // Cascade-gated chain categories are de-emphasized until the chamber is set.
    var cardStyle = 'border:1px solid var(--border);border-radius:14px;background:var(--surface);overflow:hidden' +
      (cat.cascadeGated ? ';opacity:.6' : '');
    H.push('<div style="' + cardStyle + '"' + (cat.cascadeGated ? ' data-cascade-gated="true"' : '') + '>');
    // header
    H.push('<button type="button" data-act="togglecat" data-cat="' + escAttr(cat.id) + '" aria-expanded="' + (cat.isOpen ? 'true' : 'false') + '"' + (cat.cascadeGated ? ' aria-disabled="true"' : '') + ' style="width:100%;cursor:pointer;background:transparent;border:none;color:inherit;text-align:left;display:flex;align-items:center;gap:14px;padding:16px 18px;transition:.15s">');
    var dotColor = cat.dotState === 'sel' ? 'var(--accent)' : (cat.dotState === 'req' ? 'var(--amber)' : 'var(--muted-2)');
    H.push('<span style="width:9px;height:9px;border-radius:50%;flex-shrink:0;background:' + dotColor + ';box-shadow:0 0 0 3px ' + (cat.dotState === 'sel' ? 'var(--accent-soft, rgba(255,90,31,0.13))' : 'transparent') + '"></span>');
    H.push('<div style="min-width:0;flex:1"><div style="display:flex;align-items:center;gap:9px;flex-wrap:wrap"><span style="font:600 15px \'Oswald\',sans-serif;letter-spacing:.5px;text-transform:uppercase">' + esc(cat.name) + '</span>');
    if (cat.requiredShow) H.push('<span style="font:600 9px \'Archivo\',sans-serif;letter-spacing:1px;color:var(--accent);background:var(--surface-3);border:1px solid var(--accent);padding:2px 7px;border-radius:5px">OBLIGATORIO</span>');
    if (cat.optionalShow) H.push('<span style="font:600 9px \'Archivo\',sans-serif;letter-spacing:1px;color:var(--muted-2);border:1px solid var(--border-2);padding:2px 7px;border-radius:5px">OPCIONAL</span>');
    H.push('</div><div style="font-size:12px;color:var(--muted);margin-top:3px">' + esc(cat.chosenLabel) + '</div></div>');
    H.push('<span style="font-size:11px;color:var(--muted-2);white-space:nowrap">' + esc(cat.countLabel) + '</span>');
    H.push('<span style="font-size:16px;color:var(--muted-2);transition:transform .2s;transform:rotate(' + (cat.isOpen ? '180deg' : '0deg') + ');display:inline-block">⌄</span>');
    H.push('</button>');

    // body
    if (cat.isOpen) {
      H.push('<div style="padding:4px 18px 18px;border-top:1px solid var(--border)">');
      if (cat.cascadeGated) {
        // Progressive disclosure: chain category before the chamber is chosen.
        H.push('<div style="display:flex;align-items:center;gap:9px;margin-top:14px;padding:14px 16px;border:1px dashed var(--border-2);border-radius:10px;background:var(--surface-3);font-size:12px;color:var(--muted)"><span style="font-size:15px">🔒</span><span>' + esc(cat.cascadeGateNote) + '</span></div>');
        H.push('</div>');
        H.push('</div>');
        return H.join('');
      }
      if (cat.hasSearch) {
        H.push('<div style="display:flex;align-items:center;gap:8px;margin:14px 0 4px;flex-wrap:wrap">');
        H.push('<input type="text" data-act="search" data-cat="' + escAttr(cat.id) + '" value="' + escAttr(cat.searchValue) + '" placeholder="Filtra escribiendo…" aria-label="Filtrar ' + escAttr(cat.name) + '" style="flex:1;min-width:150px;background:var(--surface-3);border:1px solid var(--border-2);border-radius:9px;color:var(--text);font:400 13px \'Archivo\',sans-serif;padding:10px 13px;outline:none"/>');
        H.push('<button type="button" data-act="aisearch" data-cat="' + escAttr(cat.id) + '" class="cfg-grad-btn" style="cursor:pointer;flex-shrink:0;display:flex;align-items:center;gap:6px;background:linear-gradient(135deg,var(--accent),var(--accent-2));border:none;color:#171717;font:600 12px \'Archivo\',sans-serif;padding:10px 14px;border-radius:9px;transition:.15s">✨ Buscar con IA</button>');
        H.push('<span style="font-size:11px;color:var(--muted-2);white-space:nowrap;margin-left:auto">' + esc(cat.shownLabel) + '</span>');
        H.push('</div>');
      }
      if (cat.powerNoteShow) {
        H.push('<div style="display:flex;align-items:center;gap:7px;font-size:11px;color:var(--muted);margin-top:13px"><span style="width:6px;height:6px;border-radius:50%;background:var(--accent)"></span>' + esc(cat.powerNote) + '</div>');
      }

      // STAR card — the single recommended option, prominent, pre-selected.
      if (cat.star) H.push(renderStar(cat, cat.star));

      // The REST (non-star compatible options) collapse behind a toggle.
      if (cat.restCount > 0) {
        var restId = 'cfg-rest-' + slugifyId(cat.id);
        H.push('<button type="button" data-act="togglerest" data-cat="' + escAttr(cat.id) + '" aria-expanded="' + (cat.restOpen ? 'true' : 'false') + '" aria-controls="' + restId + '" class="cfg-hoverable" style="cursor:pointer;width:100%;margin-top:14px;display:flex;align-items:center;justify-content:center;gap:8px;background:transparent;border:1px dashed var(--border-2);color:var(--muted);font:600 12px \'Archivo\',sans-serif;letter-spacing:.3px;padding:11px;border-radius:10px;transition:.15s">' + esc(cat.restToggleLabel) + ' <span aria-hidden="true">' + cat.restToggleCaret + '</span></button>');
        H.push('<div id="' + restId + '"' + (cat.restOpen ? '' : ' hidden') + '>');
        if (cat.restOpen) {
          H.push('<div class="cfg-optgrid" style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-top:12px">');
          cat.restOptions.forEach(function (opt) { H.push(renderOption(cat, opt)); });
          H.push('</div>');
        }
        H.push('</div>');
      }

      // Empty-state copy when neither a star nor any rest option is shown
      // (e.g. a search query with no match).
      if (cat.noneShown) {
        H.push('<div style="color:var(--muted-2);font-size:12px;padding:14px 0">Sin opciones que coincidan.</div>');
      }
      H.push('</div>');
    }
    H.push('</div>');
    return H.join('');
  };

  // The prominent STAR card: a real <button> (data-act="toggle") badged
  // "⭐ RECOMENDADA" with a one-line reason. Selecting it goes through the same
  // toggle handler as any option, so de/selection + cascade prune keep working.
  function renderStar(cat, opt) {
    var H = [];
    var stockColMap = { in: 'var(--green)', pre: 'var(--amber)', oos: 'var(--muted)' };
    var stockBgMap = { in: 'rgba(70,196,99,0.16)', pre: 'rgba(232,164,23,0.16)', oos: 'rgba(150,150,150,0.18)' };
    var sel = opt.isSelected;
    var ring = sel ? 'var(--accent)' : 'var(--green)';
    H.push('<div style="margin-top:14px">');
    // Wrapper card with an accented border so it reads as the hero option.
    H.push('<div style="position:relative;border:1.5px solid ' + ring + ';border-radius:13px;background:var(--surface-2);overflow:hidden;box-shadow:' + (sel ? '0 0 0 1px var(--accent),0 12px 30px rgba(0,0,0,0.4)' : '0 0 0 1px rgba(70,196,99,0.25),0 8px 22px rgba(0,0,0,0.28)') + '">');
    // Top ribbon: recommended badge + stock.
    H.push('<div style="display:flex;align-items:center;gap:8px;padding:10px 13px;border-bottom:1px solid var(--border);background:linear-gradient(90deg,rgba(70,196,99,0.14),transparent)">');
    H.push('<span style="font:700 10px \'Archivo\',sans-serif;letter-spacing:1px;color:#171717;background:var(--green);padding:4px 9px;border-radius:6px">⭐ RECOMENDADA</span>');
    H.push('<span style="font:600 9px \'Archivo\',sans-serif;letter-spacing:1px;color:' + stockColMap[opt.stockCls] + ';background:' + stockBgMap[opt.stockCls] + ';border:1px solid ' + stockColMap[opt.stockCls] + ';padding:3px 8px;border-radius:5px">' + esc(opt.stockText) + '</span>');
    if (opt.lowShow) H.push('<span style="font:600 9px \'Archivo\',sans-serif;letter-spacing:.5px;color:var(--amber);margin-left:auto">⚠ ÚLTIMAS</span>');
    H.push('</div>');
    // Body row: image + details.
    H.push('<div style="display:flex;gap:14px;padding:14px 15px;align-items:center;flex-wrap:wrap">');
    var imgBg = opt.imageUrl
      ? 'center/cover no-repeat url(\'' + escAttr(opt.imageUrl + (opt.imageUrl.indexOf('?') >= 0 ? '&width=240' : '&width=240')) + '\')'
      : 'linear-gradient(135deg,rgba(255,90,31,0.14),var(--surface-2)),repeating-linear-gradient(45deg,#1a1a1a 0 11px,#1f1f1f 11px 22px)';
    H.push('<div style="width:96px;height:72px;border-radius:9px;flex-shrink:0;background:' + imgBg + '"></div>');
    H.push('<div style="flex:1;min-width:160px">');
    H.push('<div style="font:600 9px \'Archivo\',sans-serif;letter-spacing:1px;color:var(--muted-2);text-transform:uppercase;margin-bottom:2px">' + esc(opt.brand) + '</div>');
    H.push('<div style="font:600 15px/1.25 \'Archivo\',sans-serif;color:var(--text)">' + esc(opt.title) + '</div>');
    H.push('<div style="font:600 17px \'Oswald\',sans-serif;color:var(--text-strong);margin-top:5px">' + esc(opt.priceLabel) + '</div>');
    if (opt.reason) H.push('<div style="display:flex;align-items:flex-start;gap:6px;font-size:11.5px;line-height:1.4;color:var(--muted);margin-top:7px"><span style="color:var(--green);flex-shrink:0">✓</span><span>' + esc(opt.reason) + '</span></div>');
    H.push('</div>');
    // Action column.
    H.push('<div style="display:flex;flex-direction:column;gap:7px;min-width:160px;flex:1">');
    if (opt.isOOS) {
      var fStyle = 'cursor:pointer;background:' + (opt.factorySel ? 'var(--amber)' : 'rgba(232,164,23,0.13)') + ';border:1px solid ' + (opt.factorySel ? 'var(--amber)' : 'rgba(232,164,23,0.42)') + ';color:' + (opt.factorySel ? '#171717' : 'var(--amber)') + ';font:600 12px \'Archivo\',sans-serif;padding:10px;border-radius:9px;transition:.15s';
      H.push('<button type="button" data-act="factory" data-cat="' + escAttr(cat.id) + '" data-opt="' + escAttr(opt.id) + '" style="' + fStyle + '">🏭 Pedir de fábrica · ' + esc(opt.lead) + '</button>');
      H.push('<button type="button" data-act="alt" data-cat="' + escAttr(cat.id) + '" class="cfg-hoverable" style="cursor:pointer;background:transparent;border:1px solid var(--border-2);color:var(--text);font:500 11px \'Archivo\',sans-serif;padding:9px;border-radius:9px;transition:.15s">Ver alternativa en stock ›</button>');
    } else if (opt.qtyShow) {
      H.push('<div style="display:flex;align-items:center;gap:8px">');
      H.push('<button type="button" data-act="qtydec" data-cat="' + escAttr(cat.id) + '" class="cfg-hoverable" aria-label="Menos" style="cursor:pointer;width:34px;height:34px;border-radius:8px;background:var(--surface-3);border:1px solid var(--border-2);color:var(--text);font-size:17px;line-height:1;flex-shrink:0;transition:.15s">−</button>');
      H.push('<div style="flex:1;text-align:center;font:600 12px \'Oswald\',sans-serif;color:var(--text)">' + esc(opt.qtyLabel) + '</div>');
      H.push('<button type="button" data-act="qtyinc" data-cat="' + escAttr(cat.id) + '" class="cfg-hoverable" aria-label="Más" style="cursor:pointer;width:34px;height:34px;border-radius:8px;background:var(--surface-3);border:1px solid var(--border-2);color:var(--text);font-size:17px;line-height:1;flex-shrink:0;transition:.15s">+</button>');
      H.push('</div>');
      H.push('<button type="button" data-act="toggle" data-cat="' + escAttr(cat.id) + '" data-opt="' + escAttr(opt.id) + '" aria-pressed="true" style="cursor:pointer;width:100%;background:transparent;border:1px solid var(--accent);color:var(--accent);font:600 11px \'Archivo\',sans-serif;padding:8px;border-radius:9px">✓ En el build · quitar</button>');
    } else {
      var pStyle = sel
        ? 'cursor:pointer;width:100%;background:var(--accent-soft, rgba(255,90,31,0.13));border:1px solid var(--accent);color:var(--accent);font:600 13px \'Archivo\',sans-serif;padding:11px;border-radius:10px;transition:.15s'
        : 'cursor:pointer;width:100%;background:linear-gradient(135deg,var(--accent),var(--accent-2));border:none;color:#171717;font:700 13px \'Archivo\',sans-serif;padding:11px;border-radius:10px;transition:.15s';
      H.push('<button type="button" data-act="toggle" data-cat="' + escAttr(cat.id) + '" data-opt="' + escAttr(opt.id) + '" aria-pressed="' + (sel ? 'true' : 'false') + '" style="' + pStyle + '">' + (sel ? '✓ Añadida al build' : 'Elegir la recomendada') + '</button>');
    }
    H.push('</div>');
    H.push('</div></div></div>');
    return H.join('');
  }

  function renderOption(cat, opt) {
    var H = [];
    var stockColMap = { in: 'var(--green)', pre: 'var(--amber)', oos: 'var(--muted)' };
    var stockBgMap = { in: 'rgba(70,196,99,0.16)', pre: 'rgba(232,164,23,0.16)', oos: 'rgba(150,150,150,0.18)' };
    var ring = opt.isSelected ? 'var(--accent)' : 'var(--border)';
    H.push('<div><div style="position:relative;border:1px solid ' + ring + ';border-radius:11px;background:var(--surface-2);overflow:hidden;transition:.18s;box-shadow:' + (opt.isSelected ? '0 0 0 1px var(--accent),0 10px 26px rgba(0,0,0,0.4)' : 'none') + '">');
    // image
    var imgBg = opt.imageUrl
      ? 'center/cover no-repeat url(\'' + escAttr(opt.imageUrl + (opt.imageUrl.indexOf('?') >= 0 ? '&width=240' : '&width=240')) + '\')'
      : 'linear-gradient(135deg,rgba(255,90,31,0.14),var(--surface-2)),repeating-linear-gradient(45deg,#1a1a1a 0 11px,#1f1f1f 11px 22px)';
    H.push('<div style="position:relative;height:96px;display:flex;align-items:center;justify-content:center;background:' + imgBg + '">');
    if (!opt.imageUrl) H.push('<span style="font:600 10px \'Archivo\',sans-serif;letter-spacing:2px;color:var(--muted-2);opacity:.7;text-transform:uppercase">' + esc(opt.brand) + '</span>');
    H.push('<span style="position:absolute;top:8px;left:8px;font:600 8px \'Archivo\',sans-serif;letter-spacing:1px;color:' + stockColMap[opt.stockCls] + ';background:' + stockBgMap[opt.stockCls] + ';border:1px solid ' + stockColMap[opt.stockCls] + ';padding:3px 7px;border-radius:5px">' + esc(opt.stockText) + '</span>');
    if (opt.isSelected) H.push('<span style="position:absolute;top:8px;right:8px;width:22px;height:22px;border-radius:50%;background:var(--accent);color:#171717;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700">✓</span>');
    if (opt.recShow) H.push('<span style="position:absolute;bottom:8px;left:8px;font:600 8px \'Archivo\',sans-serif;letter-spacing:1px;color:#171717;background:var(--green);padding:2px 6px;border-radius:4px">RECOMENDADO</span>');
    H.push('</div>');
    // body
    H.push('<div style="padding:11px 12px 12px">');
    H.push('<div style="font:600 9px \'Archivo\',sans-serif;letter-spacing:1px;color:var(--muted-2);text-transform:uppercase;margin-bottom:3px">' + esc(opt.brand) + '</div>');
    H.push('<div style="font:500 13px/1.25 \'Archivo\',sans-serif;color:var(--text);min-height:32px">' + esc(opt.title) + '</div>');
    H.push('<div style="display:flex;align-items:center;justify-content:space-between;margin-top:8px"><span style="font:600 15px \'Oswald\',sans-serif;color:var(--text-strong)">' + esc(opt.priceLabel) + '</span>');
    if (opt.lowShow) H.push('<span style="font:600 9px \'Archivo\',sans-serif;letter-spacing:.5px;color:var(--amber)">⚠ ÚLTIMAS</span>');
    H.push('</div>');

    if (opt.isOOS) {
      H.push('<div style="display:flex;flex-direction:column;gap:6px;margin-top:10px">');
      var fStyle = 'cursor:pointer;background:' + (opt.factorySel ? 'var(--amber)' : 'rgba(232,164,23,0.13)') + ';border:1px solid ' + (opt.factorySel ? 'var(--amber)' : 'rgba(232,164,23,0.42)') + ';color:' + (opt.factorySel ? '#171717' : 'var(--amber)') + ';font:600 11px \'Archivo\',sans-serif;padding:7px;border-radius:7px;transition:.15s';
      H.push('<button type="button" data-act="factory" data-cat="' + escAttr(cat.id) + '" data-opt="' + escAttr(opt.id) + '" style="' + fStyle + '">🏭 Pedir de fábrica · ' + esc(opt.lead) + '</button>');
      H.push('<button type="button" data-act="alt" data-cat="' + escAttr(cat.id) + '" class="cfg-hoverable" style="cursor:pointer;background:transparent;border:1px solid var(--border-2);color:var(--text);font:500 11px \'Archivo\',sans-serif;padding:7px;border-radius:7px;transition:.15s">Ver alternativa en stock ›</button>');
      H.push('</div>');
    }
    if (opt.pillShow) {
      var pStyle = opt.isSelected
        ? 'cursor:pointer;width:100%;margin-top:10px;background:var(--accent-soft, rgba(255,90,31,0.13));border:1px solid var(--accent);color:var(--accent);font:600 12px \'Archivo\',sans-serif;padding:9px;border-radius:8px;transition:.15s'
        : 'cursor:pointer;width:100%;margin-top:10px;background:var(--surface-3);border:1px solid var(--border-2);color:var(--text);font:600 12px \'Archivo\',sans-serif;padding:9px;border-radius:8px;transition:.15s';
      H.push('<button type="button" data-act="toggle" data-cat="' + escAttr(cat.id) + '" data-opt="' + escAttr(opt.id) + '" aria-pressed="' + (opt.isSelected ? 'true' : 'false') + '" style="' + pStyle + '">' + (opt.isSelected ? '✓ Añadido al build' : 'Seleccionar') + '</button>');
    }
    if (opt.qtyShow) {
      H.push('<div style="display:flex;align-items:center;gap:8px;margin-top:10px">');
      H.push('<button type="button" data-act="qtydec" data-cat="' + escAttr(cat.id) + '" class="cfg-hoverable" aria-label="Menos" style="cursor:pointer;width:34px;height:34px;border-radius:8px;background:var(--surface-3);border:1px solid var(--border-2);color:var(--text);font-size:17px;line-height:1;flex-shrink:0;transition:.15s">−</button>');
      H.push('<div style="flex:1;text-align:center;font:600 12px \'Oswald\',sans-serif;color:var(--text)">' + esc(opt.qtyLabel) + '</div>');
      H.push('<button type="button" data-act="qtyinc" data-cat="' + escAttr(cat.id) + '" class="cfg-hoverable" aria-label="Más" style="cursor:pointer;width:34px;height:34px;border-radius:8px;background:var(--surface-3);border:1px solid var(--border-2);color:var(--text);font-size:17px;line-height:1;flex-shrink:0;transition:.15s">+</button>');
      H.push('</div>');
      H.push('<button type="button" data-act="toggle" data-cat="' + escAttr(cat.id) + '" data-opt="' + escAttr(opt.id) + '" style="cursor:pointer;width:100%;margin-top:7px;background:transparent;border:1px solid var(--accent);color:var(--accent);font:600 11px \'Archivo\',sans-serif;padding:7px;border-radius:7px">✓ En el build · quitar</button>');
    }
    H.push('</div></div></div>');
    return H.join('');
  }

  BundleConfigurator.prototype.renderMontaje = function (V) {
    var H = [];
    H.push('<div style="border:1px solid var(--border-2);border-radius:14px;background:var(--surface);overflow:hidden;margin-top:4px">');
    H.push('<div style="display:flex;align-items:center;gap:10px;padding:16px 18px;border-bottom:1px solid var(--border)"><span style="font:600 15px \'Oswald\',sans-serif;letter-spacing:.5px;text-transform:uppercase">Montaje</span><span style="font-size:12px;color:var(--muted)">Deja tu rifle montado y a punto por nuestros armeros</span></div>');
    H.push('<div class="cfg-optgrid" style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding:16px 18px">');
    V.montOpts.forEach(function (mo) {
      var on = mo.on;
      H.push('<button type="button" data-act="mont" data-mont="' + escAttr(mo.id) + '" aria-pressed="' + (on ? 'true' : 'false') + '" style="background:none;border:none;padding:0;cursor:pointer;width:100%">');
      H.push('<div style="cursor:pointer;text-align:left;background:' + (on ? 'var(--accent-soft, rgba(255,90,31,0.13))' : 'var(--surface-2)') + ';border:1px solid ' + (on ? 'var(--accent)' : 'var(--border)') + ';border-radius:12px;padding:15px;display:flex;flex-direction:column;gap:9px;transition:.15s;box-shadow:' + (on ? '0 0 0 1px var(--accent)' : 'none') + '">');
      H.push('<div style="display:flex;align-items:center;gap:9px"><span style="width:18px;height:18px;border-radius:50%;border:2px solid ' + (on ? 'var(--accent)' : 'var(--border-2)') + ';flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:11px;color:#171717;background:' + (on ? 'var(--accent)' : 'transparent') + '">' + (on ? '✓' : '') + '</span><span style="font:600 13px \'Archivo\',sans-serif;color:var(--text);flex:1">' + esc(mo.name) + '</span>');
      if (mo.badgeShow) H.push('<span style="font:600 8px \'Archivo\',sans-serif;letter-spacing:1px;color:#171717;background:var(--accent);padding:3px 7px;border-radius:5px">' + esc(mo.badge) + '</span>');
      H.push('</div>');
      H.push('<div style="font:600 17px \'Oswald\',sans-serif;color:var(--accent)">' + esc(mo.priceLabel) + '</div>');
      H.push('<div style="font-size:11px;color:var(--muted);line-height:1.45">' + esc(mo.desc) + '</div>');
      if (mo.perks.length) {
        H.push('<div style="display:flex;flex-direction:column;gap:4px;margin-top:2px">');
        mo.perks.forEach(function (perk) { H.push('<div style="display:flex;align-items:flex-start;gap:6px;font-size:11px;color:var(--text)"><span style="color:var(--accent);font-weight:700">✓</span>' + esc(perk) + '</div>'); });
        H.push('</div>');
      }
      H.push('</div></button>');
    });
    H.push('</div></div>');
    return H.join('');
  };

  BundleConfigurator.prototype.renderSummary = function (V) {
    var H = [];
    H.push('<div class="cfg-desk-summary" style="position:sticky;top:78px">');
    H.push('<div style="border:1px solid var(--border-2);border-radius:16px;background:var(--surface);overflow:hidden">');
    H.push('<div style="padding:18px 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between"><h3 style="font:600 15px \'Oswald\',sans-serif;letter-spacing:1.5px;text-transform:uppercase;margin:0">Tu build</h3><span style="font-size:11px;color:var(--muted)">' + esc(V.partsCountLabel) + '</span></div>');
    H.push('<div style="max-height:300px;overflow-y:auto;padding:8px 12px">');
    if (V.emptyShow) H.push('<div style="padding:30px 14px;text-align:center;color:var(--muted-2);font-size:12px;line-height:1.6">Usa el asistente o elige los componentes obligatorios para empezar tu build.</div>');
    V.summaryItems.forEach(function (item) {
      H.push(renderSummaryItem(item, true));
    });
    H.push('</div>');
    // discount tier
    H.push('<div style="padding:14px 20px;border-top:1px solid var(--border)"><div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px"><span style="font-size:11px;color:var(--muted)">Descuento por volumen</span><span style="font:600 12px \'Oswald\',sans-serif;color:' + (V.discPct > 0 ? 'var(--green)' : 'var(--muted-2)') + '">' + (V.discPct > 0 ? ('−' + V.discPct + '%') : '0%') + '</span></div>');
    H.push('<div style="height:7px;border-radius:6px;background:var(--surface-3);overflow:hidden;position:relative"><div style="position:absolute;left:0;top:0;bottom:0;width:' + V.tierPct + '%;background:linear-gradient(90deg,var(--accent),var(--accent-2));border-radius:6px;transition:width .4s cubic-bezier(.2,.8,.2,1)"></div><span style="position:absolute;left:40%;top:0;bottom:0;width:1px;background:var(--border-2)"></span><span style="position:absolute;left:60%;top:0;bottom:0;width:1px;background:var(--border-2)"></span></div>');
    H.push('<div style="font-size:11px;color:var(--accent);margin-top:8px">' + esc(V.tierMsg) + '</div></div>');
    // totals
    H.push('<div style="padding:14px 20px;border-top:1px solid var(--border);display:flex;flex-direction:column;gap:7px">');
    if (V.hasBase) H.push('<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--muted)"><span>Precio base</span><span>' + esc(V.basePriceLabel) + '</span></div>');
    H.push('<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--muted)"><span>Componentes</span><span>' + esc(V.partsSubtotalLabel) + '</span></div>');
    if (V.discountShow) H.push('<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--green)"><span>Descuento −' + V.discPct + '%</span><span>−' + esc(V.discAmountLabel) + '</span></div>');
    if (V.montShow) H.push('<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--muted)"><span>' + esc(V.montLabel) + '</span><span>+' + esc(V.montCostLabel) + '</span></div>');
    H.push('<div style="display:flex;justify-content:space-between;align-items:baseline;margin-top:4px;padding-top:10px;border-top:1px solid var(--border)"><span style="font:600 13px \'Oswald\',sans-serif;letter-spacing:1px;text-transform:uppercase">Total</span><span style="font:700 23px \'Oswald\',sans-serif;color:var(--text-strong)">' + esc(V.totalLabel) + '</span></div>');
    H.push('</div>');
    // cta
    H.push('<div style="padding:0 20px 20px">');
    var addStyle = V.canAdd
      ? 'cursor:pointer;width:100%;background:linear-gradient(135deg,var(--accent),var(--accent-2));border:none;color:#171717;font:700 14px \'Archivo\',sans-serif;letter-spacing:.3px;padding:15px;border-radius:12px;box-shadow:0 8px 22px rgba(255,90,31,0.2);transition:.15s'
      : 'width:100%;background:var(--surface-2);border:1px solid var(--border);color:var(--muted);font:600 13px \'Archivo\',sans-serif;padding:15px;border-radius:12px;cursor:not-allowed';
    H.push('<button type="button" data-act="add"' + (V.canAdd ? '' : ' disabled') + ' style="' + addStyle + '">' + esc(V.addLabel) + '</button>');
    if (V.cartError) H.push('<div role="alert" style="font-size:11px;color:#e0440c;text-align:center;margin-top:9px">' + esc(V.cartError) + '</div>');
    if (V.missingShow) H.push('<div style="font-size:11px;color:var(--muted);text-align:center;margin-top:9px">' + esc(V.missingMsg) + '</div>');
    H.push('</div>');
    H.push('</div></div>');
    return H.join('');
  };

  function renderSummaryItem(item, desktop) {
    var dotColor = item.dot === 'factory' ? 'var(--amber)' : item.dot === 'service' ? 'var(--accent)' : 'var(--green)';
    var H = [];
    H.push('<div class="cfg-summary-item" style="display:flex;align-items:flex-start;gap:11px;padding:' + (desktop ? '9px 8px;border-radius:9px' : '9px 0;border-bottom:1px solid var(--border)') + '">');
    H.push('<span style="width:8px;height:8px;border-radius:50%;margin-top:5px;flex-shrink:0;background:' + dotColor + '"></span>');
    H.push('<div style="flex:1;min-width:0"><div style="font-size:9px;letter-spacing:1px;color:var(--muted-2);text-transform:uppercase">' + esc(item.catName) + '</div><div style="font-size:' + (desktop ? '12px' : '13px') + ';color:var(--text);line-height:1.3">' + esc(item.optTitle) + '</div>');
    if (item.flagShow) {
      var flagCol = item.flagCls === 'factory' ? 'var(--amber)' : 'var(--accent)';
      var flagBg = item.flagCls === 'factory' ? 'rgba(232,164,23,0.13)' : 'var(--accent-soft, rgba(255,90,31,0.13))';
      H.push('<div style="display:inline-block;margin-top:3px;font:600 9px \'Archivo\',sans-serif;letter-spacing:.5px;color:' + flagCol + ';background:' + flagBg + ';padding:2px 6px;border-radius:4px">' + esc(item.flag) + '</div>');
    }
    H.push('</div>');
    H.push('<div style="text-align:right;white-space:nowrap"><div style="font:600 12px \'Oswald\',sans-serif;color:var(--text)">' + esc(item.priceLabel) + '</div>');
    if (desktop) {
      var ra = item.removeAct;
      var attrs = ra.act === 'mont' ? ' data-act="mont" data-mont="' + escAttr(ra.mont) + '"' : ' data-act="remove" data-cat="' + escAttr(ra.cat) + '"';
      H.push('<button type="button"' + attrs + ' class="cfg-remove-btn" style="cursor:pointer;background:none;border:none;color:var(--muted-2);font-size:10px;padding:2px 0">quitar</button>');
    }
    H.push('</div></div>');
    return H.join('');
  }

  BundleConfigurator.prototype.renderMobileBar = function (V) {
    var H = [];
    H.push('<div class="cfg-mobilebar" style="display:none;position:fixed;left:0;right:0;bottom:0;z-index:45;flex-direction:column;background:var(--bar-bg);backdrop-filter:blur(14px);border-top:1px solid var(--border-2)">');
    if (V.sheetOpen) {
      H.push('<div style="max-height:52vh;overflow-y:auto;padding:14px 18px 4px">');
      V.summaryItems.forEach(function (item) { H.push(renderSummaryItem(item, false)); });
      H.push('<div style="font-size:11px;color:var(--accent);padding:12px 0 4px">' + esc(V.tierMsg) + '</div>');
      H.push('</div>');
    }
    H.push('<div style="display:flex;align-items:center;gap:12px;padding:12px 18px;padding-bottom:calc(12px + env(safe-area-inset-bottom))">');
    H.push('<button type="button" data-act="sheet" aria-expanded="' + (V.sheetOpen ? 'true' : 'false') + '" style="cursor:pointer;background:transparent;border:none;text-align:left;color:inherit;flex:1;min-width:0"><div style="font-size:10px;letter-spacing:1px;color:var(--muted-2);text-transform:uppercase">Total · ' + esc(V.partsCountLabel) + ' ' + V.sheetCaret + '</div><div data-desde style="font:700 22px \'Oswald\',sans-serif;color:var(--text-strong);line-height:1.1">' + esc(V.desdeBig) + '</div></button>');
    var addStyleM = V.canAdd
      ? 'cursor:pointer;flex-shrink:0;white-space:nowrap;background:linear-gradient(135deg,var(--accent),var(--accent-2));border:none;color:#171717;font:700 13px \'Archivo\',sans-serif;letter-spacing:.3px;padding:14px 18px;border-radius:11px;transition:.15s'
      : 'flex-shrink:0;white-space:nowrap;background:var(--surface-2);border:1px solid var(--border);color:var(--muted);font:600 12px \'Archivo\',sans-serif;padding:14px 18px;border-radius:11px;cursor:not-allowed';
    H.push('<button type="button" data-act="add"' + (V.canAdd ? '' : ' disabled') + ' style="' + addStyleM + '">' + esc(V.addLabelShort) + '</button>');
    H.push('</div></div>');
    return H.join('');
  };

  /* ─── Event delegation (bound once on the mount) ─────────────────────── */

  BundleConfigurator.prototype.bind = function () {
    var self = this;
    this._bound = true;

    this.mount.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-act]');
      if (!btn || !self.mount.contains(btn)) return;
      var act = btn.getAttribute('data-act');
      var cat = btn.getAttribute('data-cat');
      var opt = btn.getAttribute('data-opt');
      switch (act) {
        case 'theme': self.setTheme(); break;
        case 'focuschat': self.focusChat(); break;
        case 'resetqa': self.resetQa(); break;
        case 'autoconf': self.autoConfigure(); break;
        case 'answer': self.answer(btn.getAttribute('data-v')); break;
        case 'qasend': self.qaSend(); break;
        case 'power': self.setPower(btn.getAttribute('data-power')); break;
        case 'color': self.setColor(btn.getAttribute('data-color')); break;
        case 'togglecat': self.toggleCat(cat); break;
        case 'togglerest': self.toggleRest(cat); break;
        case 'toggle': self.toggleStock(cat, opt); break;
        case 'factory': self.selFactory(cat, opt); break;
        case 'alt': self.selAlt(cat); break;
        case 'qtyinc': self.setQty(cat, 1); break;
        case 'qtydec': self.setQty(cat, -1); break;
        case 'aisearch': self.aiSearch(cat); break;
        case 'mont': self.setMontaje(btn.getAttribute('data-mont')); break;
        case 'remove': self.removeSel(cat); break;
        case 'sheet': self.setState(function (s) { return { sheet: !s.sheet }; }); break;
        case 'add': self.addToCart(); break;
        default: break;
      }
    });

    // Inputs (search + qa) — keep state synced without re-rendering on every
    // keystroke (re-render would steal focus). We update state silently and
    // only re-render the surrounding bits when needed.
    this.mount.addEventListener('input', function (e) {
      var t = e.target;
      var act = t.getAttribute && t.getAttribute('data-act');
      if (t.id === 'qa-input') {
        self.state.qaInput = t.value; // silent: no re-render (preserve caret)
        return;
      }
      if (act === 'search') {
        var cid = t.getAttribute('data-cat');
        var caret = t.selectionStart;
        self.setState(function (s) {
          var n = Object.assign({}, s.search); n[cid] = t.value; return { search: n };
        });
        // restore focus + caret after re-render
        var input = self.mount.querySelector('[data-act="search"][data-cat="' + cid + '"]');
        if (input) { input.focus(); try { input.setSelectionRange(caret, caret); } catch (e2) {} }
      }
    });

    this.mount.addEventListener('keydown', function (e) {
      if (e.target.id === 'qa-input' && e.key === 'Enter') {
        e.preventDefault();
        self.qaSend();
      }
    });
  };

  /* ─── Public mount entrypoint ────────────────────────────────────────── */

  window.SkirmBundleConfigurator = {
    mount: function (cfg) {
      var node = (typeof cfg.mount === 'string') ? document.querySelector(cfg.mount) : cfg.mount;
      if (!node) { if (window.console) console.error('[bundle-configurator] mount node not found'); return null; }
      var inst = new BundleConfigurator({
        mount: node,
        slug: cfg.slug,
        apiBase: cfg.apiBase,
        basePrice: cfg.basePrice
      });
      inst.load();
      return inst;
    }
  };

  /* ============================================================================
     FEATURE-DETECTED CONTRACT (so the backend can fill these in later):

     category.categoryKind : 'power' | 'color' | 'part'   (default 'part')
         - 'power'  → its options become the power selector tiers (julios/fps).
         - 'color'  → its options become the swatch row (needs colorName+colorHex).
         - 'part'   → normal component category (default).
     category.minSelectable / category.maxSelectable : number (reserved; only
         `required` is enforced today).
     category.search    : boolean  (force search box; else auto when options
         OR optionCount >= 40).
     category.optionCount : number (total count for the "Mostrando X de N" label
         and the search threshold when not all options are inlined).
     category.qtyEnabled : boolean (force qty steppers; else name-match
         Cargadores/BBs/Munición/Gas).
     category.sortOrder  : number (render order).
     category.slug    : string (canonical cascade slug, e.g. 'hop-up-chamber',
         'bucking', 'inner-barrel', 'outer-barrel', 'suppressor'). Used to wire
         a platform's CASCADE_RULES entry. When absent it is derived from the
         category name/id via CATEGORY_SLUG_ALIASES. Platforms with no
         CASCADE_RULES entry ignore this field entirely (no gating).

     option.compatibility : string[] of cut/cascade tags (e.g.
         ['srs-morpheus-chamber','vsr-cut']) driving the sequential
         compatibility cascade. Also accepted as option.tags. Untagged options
         are treated as UNIVERSAL (shown for every cut family). Independent of
         the joule `comp` array below.
     option.comp      : string[] of joule ids (e.g. ['2.3J']) → compatibility.
     option.joules    : string|number → wrapped into a 1-element comp array.
     option.fps       : string|number → power tier FPS label.
     option.colorName : string  → swatch label (with colorHex).
     option.colorHex  : string  → swatch fill (with colorName).
     option.brandLine : string  → brand line shown above the title.
     option.variantId : Shopify variant id → forwarded into /configure & /cart
         selections; used directly for /cart/add.js if /cart echoes it back.
     option.inventoryQty : number → drives the "⚠ ÚLTIMAS" low-stock badge (<=5).
     ============================================================================ */
})();
